export const GENERATED_MAP_MODULES = {
  "./maps/cauldron/basin-bash.json": {
    "format": "ash-run-map-bundle-v1",
    "id": "basin-bash",
    "name": "Basin Bash",
    "stages": [
      {
        "id": "basin-bash-stage-1",
        "name": "Basin Bash",
        "theme": "ash",
        "width": 18,
        "height": 12,
        "tiles": [
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest"
          ],
          [
            "road",
            "road",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "forest"
          ],
          [
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "forest",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "water"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "basin-bash-stage-1-player-motor-pool-10-2",
            "type": "motor-pool",
            "owner": "player",
            "x": 10,
            "y": 2
          },
          {
            "id": "basin-bash-stage-1-player-repair-station-7-2",
            "type": "repair-station",
            "owner": "player",
            "x": 7,
            "y": 2
          },
          {
            "id": "basin-bash-stage-1-player-sector-8-3",
            "type": "sector",
            "owner": "player",
            "x": 8,
            "y": 3
          },
          {
            "id": "basin-bash-stage-1-player-command-9-3",
            "type": "command",
            "owner": "player",
            "x": 9,
            "y": 3
          },
          {
            "id": "basin-bash-stage-1-player-barracks-10-4",
            "type": "barracks",
            "owner": "player",
            "x": 10,
            "y": 4
          },
          {
            "id": "basin-bash-stage-1-player-hospital-7-4",
            "type": "hospital",
            "owner": "player",
            "x": 7,
            "y": 4
          }
        ],
        "units": [
          {
            "id": "basin-bash-stage-1-enemy-bruiser-0-0",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 1,
            "x": 0,
            "y": 0
          },
          {
            "id": "basin-bash-stage-1-enemy-runner-16-1",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 16,
            "y": 1
          },
          {
            "id": "basin-bash-stage-1-enemy-longshot-7-10",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 1,
            "x": 7,
            "y": 10
          },
          {
            "id": "basin-bash-stage-1-enemy-grunt-8-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 8,
            "y": 10
          },
          {
            "id": "basin-bash-stage-1-enemy-runner-8-11",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 8,
            "y": 11
          },
          {
            "id": "basin-bash-stage-1-enemy-medic-9-11",
            "unitTypeId": "medic",
            "owner": "enemy",
            "level": 1,
            "x": 9,
            "y": 11
          },
          {
            "id": "basin-bash-stage-1-enemy-breaker-8-9",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 8,
            "y": 9
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-grunt-0-11",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 0,
                "y": 11
              },
              {
                "id": "wave-1-runner-17-11",
                "unitTypeId": "runner",
                "level": 1,
                "x": 17,
                "y": 11
              },
              {
                "id": "wave-1-grunt-9-11",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 9,
                "y": 11
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 9,
            "y": 3
          },
          "turnLimit": 5
        },
        "runStages": [
          1
        ],
        "stage": 1,
        "variantStage": 1
      },
      {
        "id": "basin-bash-stage-2",
        "name": "Basin Bash",
        "theme": "ash",
        "width": 18,
        "height": 12,
        "tiles": [
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest"
          ],
          [
            "road",
            "road",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "forest"
          ],
          [
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "forest",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "water"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "basin-bash-stage-2-player-motor-pool-10-2",
            "type": "motor-pool",
            "owner": "player",
            "x": 10,
            "y": 2
          },
          {
            "id": "basin-bash-stage-2-player-repair-station-7-2",
            "type": "repair-station",
            "owner": "player",
            "x": 7,
            "y": 2
          },
          {
            "id": "basin-bash-stage-2-player-sector-8-3",
            "type": "sector",
            "owner": "player",
            "x": 8,
            "y": 3
          },
          {
            "id": "basin-bash-stage-2-player-command-9-3",
            "type": "command",
            "owner": "player",
            "x": 9,
            "y": 3
          },
          {
            "id": "basin-bash-stage-2-player-barracks-10-4",
            "type": "barracks",
            "owner": "player",
            "x": 10,
            "y": 4
          },
          {
            "id": "basin-bash-stage-2-player-hospital-7-4",
            "type": "hospital",
            "owner": "player",
            "x": 7,
            "y": 4
          }
        ],
        "units": [
          {
            "id": "basin-bash-stage-2-enemy-bruiser-0-0",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 1,
            "x": 0,
            "y": 0
          },
          {
            "id": "basin-bash-stage-2-enemy-runner-16-1",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 16,
            "y": 1
          },
          {
            "id": "basin-bash-stage-2-enemy-longshot-7-10",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 1,
            "x": 7,
            "y": 10
          },
          {
            "id": "basin-bash-stage-2-enemy-grunt-8-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 8,
            "y": 10
          },
          {
            "id": "basin-bash-stage-2-enemy-runner-8-11",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 8,
            "y": 11
          },
          {
            "id": "basin-bash-stage-2-enemy-medic-9-11",
            "unitTypeId": "medic",
            "owner": "enemy",
            "level": 1,
            "x": 9,
            "y": 11
          },
          {
            "id": "basin-bash-stage-2-enemy-breaker-8-9",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 8,
            "y": 9
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-runner-0-0",
                "unitTypeId": "runner",
                "level": 1,
                "x": 0,
                "y": 0
              },
              {
                "id": "wave-1-grunt-0-11",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 0,
                "y": 11
              },
              {
                "id": "wave-1-runner-17-11",
                "unitTypeId": "runner",
                "level": 1,
                "x": 17,
                "y": 11
              },
              {
                "id": "wave-1-grunt-9-11",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 9,
                "y": 11
              },
              {
                "id": "wave-1-grunt-9-9",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 9,
                "y": 9
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 9,
            "y": 3
          },
          "turnLimit": 5
        },
        "runStages": [
          2
        ],
        "stage": 2,
        "variantStage": 2
      },
      {
        "id": "basin-bash-stage-3",
        "name": "Basin Bash",
        "theme": "ash",
        "width": 18,
        "height": 12,
        "tiles": [
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest"
          ],
          [
            "road",
            "road",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "forest"
          ],
          [
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "forest",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "water"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "basin-bash-stage-3-player-motor-pool-10-2",
            "type": "motor-pool",
            "owner": "player",
            "x": 10,
            "y": 2
          },
          {
            "id": "basin-bash-stage-3-player-repair-station-7-2",
            "type": "repair-station",
            "owner": "player",
            "x": 7,
            "y": 2
          },
          {
            "id": "basin-bash-stage-3-player-sector-8-3",
            "type": "sector",
            "owner": "player",
            "x": 8,
            "y": 3
          },
          {
            "id": "basin-bash-stage-3-player-command-9-3",
            "type": "command",
            "owner": "player",
            "x": 9,
            "y": 3
          },
          {
            "id": "basin-bash-stage-3-player-barracks-10-4",
            "type": "barracks",
            "owner": "player",
            "x": 10,
            "y": 4
          },
          {
            "id": "basin-bash-stage-3-player-hospital-7-4",
            "type": "hospital",
            "owner": "player",
            "x": 7,
            "y": 4
          }
        ],
        "units": [
          {
            "id": "basin-bash-stage-3-enemy-runner-0-0",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 0
          },
          {
            "id": "basin-bash-stage-3-enemy-longshot-0-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 1
          },
          {
            "id": "basin-bash-stage-3-enemy-runner-16-1",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 1
          },
          {
            "id": "basin-bash-stage-3-enemy-grunt-0-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 10
          },
          {
            "id": "basin-bash-stage-3-enemy-runner-1-10",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 1,
            "y": 10
          },
          {
            "id": "basin-bash-stage-3-enemy-grunt-8-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 10
          },
          {
            "id": "basin-bash-stage-3-enemy-breaker-16-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 2
          },
          {
            "id": "basin-bash-stage-3-enemy-breaker-8-9",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 9
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-breaker-0-11",
                "unitTypeId": "breaker",
                "level": 2,
                "x": 0,
                "y": 11
              },
              {
                "id": "wave-1-breaker-17-11",
                "unitTypeId": "breaker",
                "level": 2,
                "x": 17,
                "y": 11
              },
              {
                "id": "wave-1-grunt-8-11",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 8,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-runner-0-0",
                "unitTypeId": "runner",
                "level": 2,
                "x": 0,
                "y": 0
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-3-bruiser-0-2",
                "unitTypeId": "bruiser",
                "level": 2,
                "x": 0,
                "y": 2
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 9,
            "y": 3
          },
          "turnLimit": 5
        },
        "runStages": [
          3
        ],
        "stage": 3,
        "variantStage": 3
      },
      {
        "id": "basin-bash-stage-4",
        "name": "Basin Bash",
        "theme": "ash",
        "width": 18,
        "height": 12,
        "tiles": [
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest"
          ],
          [
            "road",
            "road",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "forest"
          ],
          [
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "forest",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "water"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "basin-bash-stage-4-player-motor-pool-10-2",
            "type": "motor-pool",
            "owner": "player",
            "x": 10,
            "y": 2
          },
          {
            "id": "basin-bash-stage-4-player-repair-station-7-2",
            "type": "repair-station",
            "owner": "player",
            "x": 7,
            "y": 2
          },
          {
            "id": "basin-bash-stage-4-player-sector-8-3",
            "type": "sector",
            "owner": "player",
            "x": 8,
            "y": 3
          },
          {
            "id": "basin-bash-stage-4-player-command-9-3",
            "type": "command",
            "owner": "player",
            "x": 9,
            "y": 3
          },
          {
            "id": "basin-bash-stage-4-player-barracks-10-4",
            "type": "barracks",
            "owner": "player",
            "x": 10,
            "y": 4
          },
          {
            "id": "basin-bash-stage-4-player-hospital-7-4",
            "type": "hospital",
            "owner": "player",
            "x": 7,
            "y": 4
          }
        ],
        "units": [
          {
            "id": "basin-bash-stage-4-enemy-runner-0-0",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 0
          },
          {
            "id": "basin-bash-stage-4-enemy-longshot-0-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 1
          },
          {
            "id": "basin-bash-stage-4-enemy-runner-16-1",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 1
          },
          {
            "id": "basin-bash-stage-4-enemy-grunt-0-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 10
          },
          {
            "id": "basin-bash-stage-4-enemy-runner-1-10",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 1,
            "y": 10
          },
          {
            "id": "basin-bash-stage-4-enemy-grunt-8-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 10
          },
          {
            "id": "basin-bash-stage-4-enemy-breaker-16-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 2
          },
          {
            "id": "basin-bash-stage-4-enemy-breaker-8-9",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 9
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-breaker-0-11",
                "unitTypeId": "breaker",
                "level": 2,
                "x": 0,
                "y": 11
              },
              {
                "id": "wave-1-breaker-17-11",
                "unitTypeId": "breaker",
                "level": 2,
                "x": 17,
                "y": 11
              },
              {
                "id": "wave-1-grunt-8-11",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 8,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-runner-0-0",
                "unitTypeId": "runner",
                "level": 2,
                "x": 0,
                "y": 0
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-3-bruiser-0-2",
                "unitTypeId": "bruiser",
                "level": 2,
                "x": 0,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-4-runner-1-0",
                "unitTypeId": "runner",
                "level": 3,
                "x": 1,
                "y": 0
              },
              {
                "id": "wave-4-bruiser-7-10",
                "unitTypeId": "bruiser",
                "level": 3,
                "x": 7,
                "y": 10
              },
              {
                "id": "wave-4-runner-16-11",
                "unitTypeId": "runner",
                "level": 3,
                "x": 16,
                "y": 11
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 9,
            "y": 3
          },
          "turnLimit": 5
        },
        "runStages": [
          4
        ],
        "stage": 4,
        "variantStage": 4
      },
      {
        "id": "basin-bash-stage-5",
        "name": "Basin Bash",
        "theme": "ash",
        "width": 18,
        "height": 12,
        "tiles": [
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest"
          ],
          [
            "road",
            "road",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "forest"
          ],
          [
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "forest",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "water"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "basin-bash-stage-5-player-motor-pool-10-2",
            "type": "motor-pool",
            "owner": "player",
            "x": 10,
            "y": 2
          },
          {
            "id": "basin-bash-stage-5-player-repair-station-7-2",
            "type": "repair-station",
            "owner": "player",
            "x": 7,
            "y": 2
          },
          {
            "id": "basin-bash-stage-5-player-sector-8-3",
            "type": "sector",
            "owner": "player",
            "x": 8,
            "y": 3
          },
          {
            "id": "basin-bash-stage-5-player-command-9-3",
            "type": "command",
            "owner": "player",
            "x": 9,
            "y": 3
          },
          {
            "id": "basin-bash-stage-5-player-barracks-10-4",
            "type": "barracks",
            "owner": "player",
            "x": 10,
            "y": 4
          },
          {
            "id": "basin-bash-stage-5-player-hospital-7-4",
            "type": "hospital",
            "owner": "player",
            "x": 7,
            "y": 4
          }
        ],
        "units": [
          {
            "id": "basin-bash-stage-5-enemy-runner-0-0",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 0
          },
          {
            "id": "basin-bash-stage-5-enemy-gunship-17-0",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 17,
            "y": 0
          },
          {
            "id": "basin-bash-stage-5-enemy-longshot-0-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 1
          },
          {
            "id": "basin-bash-stage-5-enemy-runner-16-1",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 1
          },
          {
            "id": "basin-bash-stage-5-enemy-grunt-0-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 10
          },
          {
            "id": "basin-bash-stage-5-enemy-runner-1-10",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 1,
            "y": 10
          },
          {
            "id": "basin-bash-stage-5-enemy-grunt-8-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 10
          },
          {
            "id": "basin-bash-stage-5-enemy-gunship-0-11",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 0,
            "y": 11
          },
          {
            "id": "basin-bash-stage-5-enemy-breaker-16-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 2
          },
          {
            "id": "basin-bash-stage-5-enemy-breaker-8-9",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 9
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-breaker-0-11",
                "unitTypeId": "breaker",
                "level": 2,
                "x": 0,
                "y": 11
              },
              {
                "id": "wave-1-breaker-17-11",
                "unitTypeId": "breaker",
                "level": 2,
                "x": 17,
                "y": 11
              },
              {
                "id": "wave-1-grunt-8-11",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 8,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-runner-0-0",
                "unitTypeId": "runner",
                "level": 2,
                "x": 0,
                "y": 0
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-3-bruiser-0-2",
                "unitTypeId": "bruiser",
                "level": 2,
                "x": 0,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-4-runner-1-0",
                "unitTypeId": "runner",
                "level": 3,
                "x": 1,
                "y": 0
              },
              {
                "id": "wave-4-bruiser-7-10",
                "unitTypeId": "bruiser",
                "level": 3,
                "x": 7,
                "y": 10
              },
              {
                "id": "wave-4-runner-16-11",
                "unitTypeId": "runner",
                "level": 3,
                "x": 16,
                "y": 11
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 9,
            "y": 3
          },
          "turnLimit": 5
        },
        "runStages": [
          5
        ],
        "stage": 5,
        "variantStage": 5
      },
      {
        "id": "basin-bash-stage-6",
        "name": "Basin Bash",
        "theme": "ash",
        "width": 18,
        "height": 12,
        "tiles": [
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest"
          ],
          [
            "road",
            "road",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "forest"
          ],
          [
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "forest",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "water"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "basin-bash-stage-6-player-motor-pool-10-2",
            "type": "motor-pool",
            "owner": "player",
            "x": 10,
            "y": 2
          },
          {
            "id": "basin-bash-stage-6-player-repair-station-7-2",
            "type": "repair-station",
            "owner": "player",
            "x": 7,
            "y": 2
          },
          {
            "id": "basin-bash-stage-6-player-sector-8-3",
            "type": "sector",
            "owner": "player",
            "x": 8,
            "y": 3
          },
          {
            "id": "basin-bash-stage-6-player-command-9-3",
            "type": "command",
            "owner": "player",
            "x": 9,
            "y": 3
          },
          {
            "id": "basin-bash-stage-6-player-barracks-10-4",
            "type": "barracks",
            "owner": "player",
            "x": 10,
            "y": 4
          },
          {
            "id": "basin-bash-stage-6-player-hospital-7-4",
            "type": "hospital",
            "owner": "player",
            "x": 7,
            "y": 4
          }
        ],
        "units": [
          {
            "id": "basin-bash-stage-6-enemy-runner-0-0",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 0
          },
          {
            "id": "basin-bash-stage-6-enemy-gunship-17-0",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 17,
            "y": 0
          },
          {
            "id": "basin-bash-stage-6-enemy-longshot-0-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 1
          },
          {
            "id": "basin-bash-stage-6-enemy-runner-16-1",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 1
          },
          {
            "id": "basin-bash-stage-6-enemy-grunt-0-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 10
          },
          {
            "id": "basin-bash-stage-6-enemy-runner-1-10",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 1,
            "y": 10
          },
          {
            "id": "basin-bash-stage-6-enemy-grunt-8-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 10
          },
          {
            "id": "basin-bash-stage-6-enemy-gunship-0-11",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 0,
            "y": 11
          },
          {
            "id": "basin-bash-stage-6-enemy-breaker-16-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 2
          },
          {
            "id": "basin-bash-stage-6-enemy-breaker-8-9",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 9
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-bruiser-1-1",
                "unitTypeId": "bruiser",
                "level": 3,
                "x": 1,
                "y": 1
              },
              {
                "id": "wave-1-juggernaut-9-11",
                "unitTypeId": "juggernaut",
                "level": 3,
                "x": 9,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-runner-0-0",
                "unitTypeId": "runner",
                "level": 2,
                "x": 0,
                "y": 0
              },
              {
                "id": "wave-2-breaker-8-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 8,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-3-grunt-8-11",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 8,
                "y": 11
              },
              {
                "id": "wave-3-grunt-9-11",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 9,
                "y": 11
              },
              {
                "id": "wave-3-bruiser-0-2",
                "unitTypeId": "bruiser",
                "level": 2,
                "x": 0,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-4-runner-1-0",
                "unitTypeId": "runner",
                "level": 2,
                "x": 1,
                "y": 0
              },
              {
                "id": "wave-4-breaker-10-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 10,
                "y": 11
              },
              {
                "id": "wave-4-breaker-8-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 8,
                "y": 11
              },
              {
                "id": "wave-4-grunt-9-11",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 9,
                "y": 11
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 9,
            "y": 3
          },
          "turnLimit": 5
        },
        "runStages": [
          6
        ],
        "stage": 6,
        "variantStage": 6
      },
      {
        "id": "basin-bash-stage-7",
        "name": "Basin Bash",
        "theme": "ash",
        "width": 18,
        "height": 12,
        "tiles": [
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest"
          ],
          [
            "road",
            "road",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "forest"
          ],
          [
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "forest",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "water"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "basin-bash-stage-7-player-motor-pool-10-2",
            "type": "motor-pool",
            "owner": "player",
            "x": 10,
            "y": 2
          },
          {
            "id": "basin-bash-stage-7-player-repair-station-7-2",
            "type": "repair-station",
            "owner": "player",
            "x": 7,
            "y": 2
          },
          {
            "id": "basin-bash-stage-7-player-sector-8-3",
            "type": "sector",
            "owner": "player",
            "x": 8,
            "y": 3
          },
          {
            "id": "basin-bash-stage-7-player-command-9-3",
            "type": "command",
            "owner": "player",
            "x": 9,
            "y": 3
          },
          {
            "id": "basin-bash-stage-7-player-barracks-10-4",
            "type": "barracks",
            "owner": "player",
            "x": 10,
            "y": 4
          },
          {
            "id": "basin-bash-stage-7-player-hospital-7-4",
            "type": "hospital",
            "owner": "player",
            "x": 7,
            "y": 4
          }
        ],
        "units": [
          {
            "id": "basin-bash-stage-7-enemy-runner-0-0",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 0
          },
          {
            "id": "basin-bash-stage-7-enemy-gunship-17-0",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 17,
            "y": 0
          },
          {
            "id": "basin-bash-stage-7-enemy-longshot-0-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 1
          },
          {
            "id": "basin-bash-stage-7-enemy-runner-16-1",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 1
          },
          {
            "id": "basin-bash-stage-7-enemy-grunt-0-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 10
          },
          {
            "id": "basin-bash-stage-7-enemy-runner-1-10",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 1,
            "y": 10
          },
          {
            "id": "basin-bash-stage-7-enemy-grunt-8-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 10
          },
          {
            "id": "basin-bash-stage-7-enemy-gunship-0-11",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 0,
            "y": 11
          },
          {
            "id": "basin-bash-stage-7-enemy-breaker-16-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 2
          },
          {
            "id": "basin-bash-stage-7-enemy-breaker-8-9",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 9
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-bruiser-1-1",
                "unitTypeId": "bruiser",
                "level": 3,
                "x": 1,
                "y": 1
              },
              {
                "id": "wave-1-juggernaut-9-11",
                "unitTypeId": "juggernaut",
                "level": 3,
                "x": 9,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-runner-0-0",
                "unitTypeId": "runner",
                "level": 2,
                "x": 0,
                "y": 0
              },
              {
                "id": "wave-2-breaker-8-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 8,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-3-grunt-8-11",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 8,
                "y": 11
              },
              {
                "id": "wave-3-grunt-9-11",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 9,
                "y": 11
              },
              {
                "id": "wave-3-bruiser-0-2",
                "unitTypeId": "bruiser",
                "level": 2,
                "x": 0,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-4-runner-1-0",
                "unitTypeId": "runner",
                "level": 2,
                "x": 1,
                "y": 0
              },
              {
                "id": "wave-4-breaker-10-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 10,
                "y": 11
              },
              {
                "id": "wave-4-breaker-8-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 8,
                "y": 11
              },
              {
                "id": "wave-4-grunt-9-11",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 9,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-5",
            "name": "Wave 5",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-5-gunship-1-11",
                "unitTypeId": "gunship",
                "level": 4,
                "x": 1,
                "y": 11
              },
              {
                "id": "wave-5-breaker-10-11",
                "unitTypeId": "breaker",
                "level": 5,
                "x": 10,
                "y": 11
              },
              {
                "id": "wave-5-breaker-8-11",
                "unitTypeId": "breaker",
                "level": 5,
                "x": 8,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-6",
            "name": "Wave 6",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-6-breaker-8-11",
                "unitTypeId": "breaker",
                "level": 5,
                "x": 8,
                "y": 11
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 9,
            "y": 3
          },
          "turnLimit": 7
        },
        "runStages": [
          7
        ],
        "stage": 7,
        "variantStage": 7
      },
      {
        "id": "basin-bash-stage-8",
        "name": "Basin Bash",
        "theme": "ash",
        "width": 18,
        "height": 12,
        "tiles": [
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest"
          ],
          [
            "road",
            "road",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "forest"
          ],
          [
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "forest",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "water"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "basin-bash-stage-8-player-motor-pool-10-2",
            "type": "motor-pool",
            "owner": "player",
            "x": 10,
            "y": 2
          },
          {
            "id": "basin-bash-stage-8-player-repair-station-7-2",
            "type": "repair-station",
            "owner": "player",
            "x": 7,
            "y": 2
          },
          {
            "id": "basin-bash-stage-8-player-sector-8-3",
            "type": "sector",
            "owner": "player",
            "x": 8,
            "y": 3
          },
          {
            "id": "basin-bash-stage-8-player-command-9-3",
            "type": "command",
            "owner": "player",
            "x": 9,
            "y": 3
          },
          {
            "id": "basin-bash-stage-8-player-barracks-10-4",
            "type": "barracks",
            "owner": "player",
            "x": 10,
            "y": 4
          },
          {
            "id": "basin-bash-stage-8-player-hospital-7-4",
            "type": "hospital",
            "owner": "player",
            "x": 7,
            "y": 4
          }
        ],
        "units": [
          {
            "id": "basin-bash-stage-8-enemy-runner-0-0",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 0
          },
          {
            "id": "basin-bash-stage-8-enemy-gunship-17-0",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 17,
            "y": 0
          },
          {
            "id": "basin-bash-stage-8-enemy-longshot-0-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 1
          },
          {
            "id": "basin-bash-stage-8-enemy-runner-16-1",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 1
          },
          {
            "id": "basin-bash-stage-8-enemy-grunt-0-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 10
          },
          {
            "id": "basin-bash-stage-8-enemy-runner-1-10",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 1,
            "y": 10
          },
          {
            "id": "basin-bash-stage-8-enemy-grunt-8-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 10
          },
          {
            "id": "basin-bash-stage-8-enemy-gunship-0-11",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 0,
            "y": 11
          },
          {
            "id": "basin-bash-stage-8-enemy-breaker-16-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 2
          },
          {
            "id": "basin-bash-stage-8-enemy-breaker-8-9",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 9
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-bruiser-0-0",
                "unitTypeId": "bruiser",
                "level": 4,
                "x": 0,
                "y": 0
              },
              {
                "id": "wave-1-grunt-10-11",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 10,
                "y": 11
              },
              {
                "id": "wave-1-breaker-11-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 11,
                "y": 11
              },
              {
                "id": "wave-1-breaker-9-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 9,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-juggernaut-1-0",
                "unitTypeId": "juggernaut",
                "level": 4,
                "x": 1,
                "y": 0
              },
              {
                "id": "wave-2-breaker-10-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 10,
                "y": 11
              },
              {
                "id": "wave-2-breaker-8-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 8,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-3-breaker-9-11",
                "unitTypeId": "breaker",
                "level": 5,
                "x": 9,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4: Boss Grunt",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-4-grunt-8-11",
                "unitTypeId": "grunt",
                "level": 6,
                "x": 8,
                "y": 11
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 9,
            "y": 3
          },
          "turnLimit": 7
        },
        "runStages": [
          8
        ],
        "stage": 8,
        "variantStage": 8
      },
      {
        "id": "basin-bash-stage-9",
        "name": "Basin Bash",
        "theme": "ash",
        "width": 18,
        "height": 12,
        "tiles": [
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest"
          ],
          [
            "road",
            "road",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "forest"
          ],
          [
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "forest",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "water"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "basin-bash-stage-9-player-motor-pool-10-2",
            "type": "motor-pool",
            "owner": "player",
            "x": 10,
            "y": 2
          },
          {
            "id": "basin-bash-stage-9-player-repair-station-7-2",
            "type": "repair-station",
            "owner": "player",
            "x": 7,
            "y": 2
          },
          {
            "id": "basin-bash-stage-9-player-sector-8-3",
            "type": "sector",
            "owner": "player",
            "x": 8,
            "y": 3
          },
          {
            "id": "basin-bash-stage-9-player-command-9-3",
            "type": "command",
            "owner": "player",
            "x": 9,
            "y": 3
          },
          {
            "id": "basin-bash-stage-9-player-barracks-10-4",
            "type": "barracks",
            "owner": "player",
            "x": 10,
            "y": 4
          },
          {
            "id": "basin-bash-stage-9-player-hospital-7-4",
            "type": "hospital",
            "owner": "player",
            "x": 7,
            "y": 4
          }
        ],
        "units": [
          {
            "id": "basin-bash-stage-9-enemy-runner-0-0",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 0
          },
          {
            "id": "basin-bash-stage-9-enemy-gunship-17-0",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 17,
            "y": 0
          },
          {
            "id": "basin-bash-stage-9-enemy-longshot-0-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 1
          },
          {
            "id": "basin-bash-stage-9-enemy-runner-16-1",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 1
          },
          {
            "id": "basin-bash-stage-9-enemy-grunt-0-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 10
          },
          {
            "id": "basin-bash-stage-9-enemy-runner-1-10",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 1,
            "y": 10
          },
          {
            "id": "basin-bash-stage-9-enemy-grunt-8-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 10
          },
          {
            "id": "basin-bash-stage-9-enemy-gunship-0-11",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 0,
            "y": 11
          },
          {
            "id": "basin-bash-stage-9-enemy-breaker-16-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 2
          },
          {
            "id": "basin-bash-stage-9-enemy-breaker-8-9",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 9
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-bruiser-0-0",
                "unitTypeId": "bruiser",
                "level": 4,
                "x": 0,
                "y": 0
              },
              {
                "id": "wave-1-grunt-10-11",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 10,
                "y": 11
              },
              {
                "id": "wave-1-breaker-11-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 11,
                "y": 11
              },
              {
                "id": "wave-1-breaker-9-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 9,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-juggernaut-1-0",
                "unitTypeId": "juggernaut",
                "level": 4,
                "x": 1,
                "y": 0
              },
              {
                "id": "wave-2-breaker-10-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 10,
                "y": 11
              },
              {
                "id": "wave-2-breaker-8-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 8,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-3-breaker-9-11",
                "unitTypeId": "breaker",
                "level": 5,
                "x": 9,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-4-grunt-10-11",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 10,
                "y": 11
              },
              {
                "id": "wave-4-breaker-11-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 11,
                "y": 11
              },
              {
                "id": "wave-4-breaker-13-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 13,
                "y": 11
              },
              {
                "id": "wave-4-breaker-9-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 9,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-5",
            "name": "Wave 5: Boss Breaker",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-5-breaker-9-11",
                "unitTypeId": "breaker",
                "level": 7,
                "x": 9,
                "y": 11
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 9,
            "y": 3
          },
          "turnLimit": 7
        },
        "runStages": [
          9
        ],
        "stage": 9,
        "variantStage": 9
      },
      {
        "id": "basin-bash-stage-10",
        "name": "Basin Bash",
        "theme": "ash",
        "width": 18,
        "height": 12,
        "tiles": [
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest"
          ],
          [
            "road",
            "road",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "forest"
          ],
          [
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "road",
            "road",
            "mountain",
            "mountain",
            "forest",
            "mountain",
            "plain",
            "plain",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "water"
          ],
          [
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "forest"
          ],
          [
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "basin-bash-stage-10-player-motor-pool-10-2",
            "type": "motor-pool",
            "owner": "player",
            "x": 10,
            "y": 2
          },
          {
            "id": "basin-bash-stage-10-player-repair-station-7-2",
            "type": "repair-station",
            "owner": "player",
            "x": 7,
            "y": 2
          },
          {
            "id": "basin-bash-stage-10-player-sector-8-3",
            "type": "sector",
            "owner": "player",
            "x": 8,
            "y": 3
          },
          {
            "id": "basin-bash-stage-10-player-command-9-3",
            "type": "command",
            "owner": "player",
            "x": 9,
            "y": 3
          },
          {
            "id": "basin-bash-stage-10-player-barracks-10-4",
            "type": "barracks",
            "owner": "player",
            "x": 10,
            "y": 4
          },
          {
            "id": "basin-bash-stage-10-player-hospital-7-4",
            "type": "hospital",
            "owner": "player",
            "x": 7,
            "y": 4
          }
        ],
        "units": [
          {
            "id": "basin-bash-stage-10-enemy-runner-0-0",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 0
          },
          {
            "id": "basin-bash-stage-10-enemy-gunship-17-0",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 17,
            "y": 0
          },
          {
            "id": "basin-bash-stage-10-enemy-longshot-0-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 1
          },
          {
            "id": "basin-bash-stage-10-enemy-runner-16-1",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 1
          },
          {
            "id": "basin-bash-stage-10-enemy-grunt-0-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 0,
            "y": 10
          },
          {
            "id": "basin-bash-stage-10-enemy-runner-1-10",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 1,
            "y": 10
          },
          {
            "id": "basin-bash-stage-10-enemy-grunt-8-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 10
          },
          {
            "id": "basin-bash-stage-10-enemy-gunship-0-11",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 0,
            "y": 11
          },
          {
            "id": "basin-bash-stage-10-enemy-breaker-16-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 16,
            "y": 2
          },
          {
            "id": "basin-bash-stage-10-enemy-breaker-8-9",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 8,
            "y": 9
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-bruiser-0-0",
                "unitTypeId": "bruiser",
                "level": 4,
                "x": 0,
                "y": 0
              },
              {
                "id": "wave-1-grunt-10-11",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 10,
                "y": 11
              },
              {
                "id": "wave-1-breaker-11-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 11,
                "y": 11
              },
              {
                "id": "wave-1-breaker-9-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 9,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-juggernaut-1-0",
                "unitTypeId": "juggernaut",
                "level": 4,
                "x": 1,
                "y": 0
              },
              {
                "id": "wave-2-breaker-10-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 10,
                "y": 11
              },
              {
                "id": "wave-2-breaker-8-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 8,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-3-breaker-9-11",
                "unitTypeId": "breaker",
                "level": 5,
                "x": 9,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-4-grunt-10-11",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 10,
                "y": 11
              },
              {
                "id": "wave-4-breaker-11-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 11,
                "y": 11
              },
              {
                "id": "wave-4-breaker-13-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 13,
                "y": 11
              },
              {
                "id": "wave-4-breaker-9-11",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 9,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-5",
            "name": "Wave 5: Boss Grunt",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-5-grunt-8-11",
                "unitTypeId": "grunt",
                "level": 8,
                "x": 8,
                "y": 11
              }
            ]
          },
          {
            "id": "wave-6",
            "name": "Wave 6: Boss Breaker",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-6-grunt-9-11",
                "unitTypeId": "grunt",
                "level": 8,
                "x": 9,
                "y": 11
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 9,
            "y": 3
          },
          "turnLimit": 7
        },
        "runStages": [
          10
        ],
        "stage": 10,
        "variantStage": 10
      }
    ]
  },
  "./maps/cauldron/cauldron.json": {
    "format": "ash-run-map-bundle-v1",
    "id": "cauldron",
    "name": "Cauldron",
    "stages": [
      {
        "id": "cauldron-stage-1",
        "name": "Cauldron",
        "theme": "ash",
        "width": 15,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "forest",
            "forest",
            "road",
            "mountain",
            "water",
            "water",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "mountain",
            "road",
            "forest",
            "forest"
          ],
          [
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "forest",
            "forest"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cauldron-stage-1-player-command-7-6",
            "type": "command",
            "owner": "player",
            "x": 7,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cauldron-stage-1-enemy-grunt-1-4",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 4
          },
          {
            "id": "cauldron-stage-1-enemy-breaker-13-6",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 13,
            "y": 6
          },
          {
            "id": "cauldron-stage-1-enemy-grunt-1-7",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 7
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Infantry Spawns",
            "maxActivations": 11,
            "trigger": {
              "type": "player-turns-completed",
              "every": 2
            },
            "units": [
              {
                "id": "wave-1-breaker-0-5",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 0,
                "y": 5
              },
              {
                "id": "wave-1-grunt-0-6",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 0,
                "y": 6
              },
              {
                "id": "wave-1-grunt-14-5",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 14,
                "y": 5
              },
              {
                "id": "wave-1-breaker-14-6",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 14,
                "y": 6
              }
            ]
          }
        ],
        "goal": {
          "type": "survive",
          "turnLimit": 7
        },
        "runStages": [
          1
        ],
        "stage": 1,
        "variantStage": 1
      },
      {
        "id": "cauldron-stage-2",
        "name": "Cauldron",
        "theme": "ash",
        "width": 15,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "forest",
            "forest",
            "road",
            "mountain",
            "water",
            "water",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "mountain",
            "road",
            "forest",
            "forest"
          ],
          [
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "forest",
            "forest"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cauldron-stage-2-player-command-7-6",
            "type": "command",
            "owner": "player",
            "x": 7,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cauldron-stage-2-enemy-grunt-1-4",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 4
          },
          {
            "id": "cauldron-stage-2-enemy-grunt-13-5",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 13,
            "y": 5
          },
          {
            "id": "cauldron-stage-2-enemy-breaker-13-6",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 13,
            "y": 6
          },
          {
            "id": "cauldron-stage-2-enemy-grunt-1-7",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 7
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Infantry Spawns",
            "maxActivations": 12,
            "trigger": {
              "type": "player-turns-completed",
              "every": 2
            },
            "units": [
              {
                "id": "wave-1-breaker-0-5",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 0,
                "y": 5
              },
              {
                "id": "wave-1-grunt-14-5",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 14,
                "y": 5
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "More Infantry",
            "maxActivations": 8,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-0-6",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 0,
                "y": 6
              },
              {
                "id": "wave-2-grunt-14-6",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 14,
                "y": 6
              }
            ]
          }
        ],
        "goal": {
          "type": "survive",
          "turnLimit": 7
        },
        "runStages": [
          2
        ],
        "stage": 2,
        "variantStage": 2
      },
      {
        "id": "cauldron-stage-3",
        "name": "Cauldron",
        "theme": "ash",
        "width": 15,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "forest",
            "forest",
            "road",
            "mountain",
            "water",
            "water",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "mountain",
            "road",
            "forest",
            "forest"
          ],
          [
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "forest",
            "forest"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cauldron-stage-3-player-command-7-6",
            "type": "command",
            "owner": "player",
            "x": 7,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cauldron-stage-3-enemy-grunt-1-4",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 4
          },
          {
            "id": "cauldron-stage-3-enemy-grunt-13-5",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 13,
            "y": 5
          },
          {
            "id": "cauldron-stage-3-enemy-breaker-13-6",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 13,
            "y": 6
          },
          {
            "id": "cauldron-stage-3-enemy-grunt-1-7",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 7
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Infantry Spawns",
            "maxActivations": 3,
            "trigger": {
              "type": "player-turns-completed",
              "every": 2
            },
            "units": [
              {
                "id": "wave-1-breaker-0-5",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 0,
                "y": 5
              },
              {
                "id": "wave-1-grunt-14-5",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 14,
                "y": 5
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "More Infantry",
            "maxActivations": 6,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-0-6",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 0,
                "y": 6
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Runner Boss",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 5
            },
            "units": [
              {
                "id": "wave-3-runner-1-1",
                "unitTypeId": "runner",
                "level": 2,
                "x": 1,
                "y": 1
              },
              {
                "id": "wave-3-runner-13-10",
                "unitTypeId": "runner",
                "level": 2,
                "x": 13,
                "y": 10
              }
            ]
          }
        ],
        "goal": {
          "type": "survive",
          "turnLimit": 7
        },
        "runStages": [
          3
        ],
        "stage": 3,
        "variantStage": 3
      },
      {
        "id": "cauldron-stage-4",
        "name": "Cauldron",
        "theme": "ash",
        "width": 15,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "forest",
            "forest",
            "road",
            "mountain",
            "water",
            "water",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "mountain",
            "road",
            "forest",
            "forest"
          ],
          [
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "forest",
            "forest"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cauldron-stage-4-player-command-7-6",
            "type": "command",
            "owner": "player",
            "x": 7,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cauldron-stage-4-enemy-grunt-1-4",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 4
          },
          {
            "id": "cauldron-stage-4-enemy-grunt-13-5",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 13,
            "y": 5
          },
          {
            "id": "cauldron-stage-4-enemy-breaker-13-6",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 13,
            "y": 6
          },
          {
            "id": "cauldron-stage-4-enemy-grunt-1-7",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 7
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Infantry Spawns",
            "maxActivations": 3,
            "trigger": {
              "type": "player-turns-completed",
              "every": 2
            },
            "units": [
              {
                "id": "wave-1-breaker-0-5",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 0,
                "y": 5
              },
              {
                "id": "wave-1-grunt-14-5",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 14,
                "y": 5
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "More Infantry",
            "maxActivations": 6,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-0-6",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 0,
                "y": 6
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Runner Boss",
            "maxActivations": 2,
            "trigger": {
              "type": "player-turns-completed",
              "every": 3
            },
            "units": [
              {
                "id": "wave-3-runner-1-1",
                "unitTypeId": "runner",
                "level": 2,
                "x": 1,
                "y": 1
              },
              {
                "id": "wave-3-runner-13-10",
                "unitTypeId": "runner",
                "level": 2,
                "x": 13,
                "y": 10
              }
            ]
          }
        ],
        "goal": {
          "type": "survive",
          "turnLimit": 7
        },
        "runStages": [
          4
        ],
        "stage": 4,
        "variantStage": 4
      },
      {
        "id": "cauldron-stage-5",
        "name": "Cauldron",
        "theme": "ash",
        "width": 15,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "forest",
            "forest",
            "road",
            "mountain",
            "water",
            "water",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "mountain",
            "road",
            "forest",
            "forest"
          ],
          [
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "forest",
            "forest"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cauldron-stage-5-player-command-7-6",
            "type": "command",
            "owner": "player",
            "x": 7,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cauldron-stage-5-enemy-longshot-13-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 13,
            "y": 1
          },
          {
            "id": "cauldron-stage-5-enemy-bruiser-1-10",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 2,
            "x": 1,
            "y": 10
          },
          {
            "id": "cauldron-stage-5-enemy-grunt-1-4",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 4
          },
          {
            "id": "cauldron-stage-5-enemy-grunt-13-5",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 13,
            "y": 5
          },
          {
            "id": "cauldron-stage-5-enemy-breaker-13-6",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 13,
            "y": 6
          },
          {
            "id": "cauldron-stage-5-enemy-grunt-1-7",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 7
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Infantry Spawns",
            "maxActivations": 3,
            "trigger": {
              "type": "player-turns-completed",
              "every": 2
            },
            "units": [
              {
                "id": "wave-1-breaker-0-5",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 0,
                "y": 5
              },
              {
                "id": "wave-1-grunt-14-5",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 14,
                "y": 5
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "More Infantry",
            "maxActivations": 6,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-0-6",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 0,
                "y": 6
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Runner Boss",
            "maxActivations": 2,
            "trigger": {
              "type": "player-turns-completed",
              "every": 3
            },
            "units": [
              {
                "id": "wave-3-runner-1-1",
                "unitTypeId": "runner",
                "level": 2,
                "x": 1,
                "y": 1
              },
              {
                "id": "wave-3-runner-13-10",
                "unitTypeId": "runner",
                "level": 2,
                "x": 13,
                "y": 10
              }
            ]
          }
        ],
        "goal": {
          "type": "survive",
          "turnLimit": 7
        },
        "runStages": [
          5
        ],
        "stage": 5,
        "variantStage": 5
      },
      {
        "id": "cauldron-stage-6",
        "name": "Cauldron",
        "theme": "ash",
        "width": 15,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "forest",
            "forest",
            "road",
            "mountain",
            "water",
            "water",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "mountain",
            "road",
            "forest",
            "forest"
          ],
          [
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "forest",
            "forest"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cauldron-stage-6-player-command-7-6",
            "type": "command",
            "owner": "player",
            "x": 7,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cauldron-stage-6-enemy-longshot-13-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 13,
            "y": 1
          },
          {
            "id": "cauldron-stage-6-enemy-bruiser-1-10",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 2,
            "x": 1,
            "y": 10
          },
          {
            "id": "cauldron-stage-6-enemy-grunt-1-4",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 4
          },
          {
            "id": "cauldron-stage-6-enemy-grunt-13-5",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 13,
            "y": 5
          },
          {
            "id": "cauldron-stage-6-enemy-breaker-13-6",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 13,
            "y": 6
          },
          {
            "id": "cauldron-stage-6-enemy-grunt-1-7",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 7
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Infantry Spawns",
            "maxActivations": 3,
            "trigger": {
              "type": "player-turns-completed",
              "every": 2
            },
            "units": [
              {
                "id": "wave-1-breaker-0-5",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 0,
                "y": 5
              },
              {
                "id": "wave-1-grunt-14-5",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 14,
                "y": 5
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "More Infantry",
            "maxActivations": 6,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-0-6",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 0,
                "y": 6
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Runner Boss",
            "maxActivations": 2,
            "trigger": {
              "type": "player-turns-completed",
              "every": 3
            },
            "units": [
              {
                "id": "wave-3-runner-1-1",
                "unitTypeId": "runner",
                "level": 2,
                "x": 1,
                "y": 1
              },
              {
                "id": "wave-3-runner-13-10",
                "unitTypeId": "runner",
                "level": 2,
                "x": 13,
                "y": 10
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Siege Gun",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "cauldron-stage-6-enemy-longshot-13-1"
            },
            "units": [
              {
                "id": "wave-4-longshot-1-7",
                "unitTypeId": "longshot",
                "level": 2,
                "x": 1,
                "y": 7
              },
              {
                "id": "wave-4-siege-gun-2-9",
                "unitTypeId": "siege-gun",
                "level": 3,
                "x": 2,
                "y": 9
              }
            ]
          }
        ],
        "goal": {
          "type": "survive",
          "turnLimit": 7
        },
        "runStages": [
          6
        ],
        "stage": 6,
        "variantStage": 6
      },
      {
        "id": "cauldron-stage-7",
        "name": "Cauldron",
        "theme": "ash",
        "width": 15,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "forest",
            "forest",
            "road",
            "mountain",
            "water",
            "water",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "mountain",
            "road",
            "forest",
            "forest"
          ],
          [
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "forest",
            "forest"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cauldron-stage-7-player-command-7-6",
            "type": "command",
            "owner": "player",
            "x": 7,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cauldron-stage-7-enemy-longshot-13-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 13,
            "y": 1
          },
          {
            "id": "cauldron-stage-7-enemy-bruiser-1-10",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 2,
            "x": 1,
            "y": 10
          },
          {
            "id": "cauldron-stage-7-enemy-grunt-1-4",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 4
          },
          {
            "id": "cauldron-stage-7-enemy-grunt-13-5",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 13,
            "y": 5
          },
          {
            "id": "cauldron-stage-7-enemy-breaker-13-6",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 13,
            "y": 6
          },
          {
            "id": "cauldron-stage-7-enemy-grunt-1-7",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 7
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Infantry Spawns",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 2
            },
            "units": [
              {
                "id": "wave-1-breaker-0-5",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 0,
                "y": 5
              },
              {
                "id": "wave-1-grunt-14-5",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 14,
                "y": 5
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "More Infantry",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-0-6",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 0,
                "y": 6
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Runner Boss",
            "maxActivations": 2,
            "trigger": {
              "type": "player-turns-completed",
              "every": 3
            },
            "units": [
              {
                "id": "wave-3-runner-1-1",
                "unitTypeId": "runner",
                "level": 2,
                "x": 1,
                "y": 1
              },
              {
                "id": "wave-3-runner-13-10",
                "unitTypeId": "runner",
                "level": 2,
                "x": 13,
                "y": 10
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Siege Gun",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "cauldron-stage-7-enemy-longshot-13-1"
            },
            "units": [
              {
                "id": "wave-4-longshot-1-7",
                "unitTypeId": "longshot",
                "level": 2,
                "x": 1,
                "y": 7
              },
              {
                "id": "wave-4-siege-gun-2-9",
                "unitTypeId": "siege-gun",
                "level": 3,
                "x": 2,
                "y": 9
              }
            ]
          },
          {
            "id": "wave-5",
            "name": "Kill Counter",
            "maxActivations": 15,
            "trigger": {
              "type": "enemy-casualties",
              "every": 5
            },
            "units": [
              {
                "id": "wave-5-longshot-12-1",
                "unitTypeId": "longshot",
                "level": 5,
                "x": 12,
                "y": 1
              },
              {
                "id": "wave-5-siege-gun-3-1",
                "unitTypeId": "siege-gun",
                "level": 3,
                "x": 3,
                "y": 1
              },
              {
                "id": "wave-5-breaker-3-10",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 3,
                "y": 10
              },
              {
                "id": "wave-5-medic-12-2",
                "unitTypeId": "medic",
                "level": 5,
                "x": 12,
                "y": 2
              },
              {
                "id": "wave-5-medic-1-9",
                "unitTypeId": "medic",
                "level": 5,
                "x": 1,
                "y": 9
              }
            ]
          }
        ],
        "goal": {
          "type": "survive",
          "turnLimit": 7
        },
        "runStages": [
          7
        ],
        "stage": 7,
        "variantStage": 7
      },
      {
        "id": "cauldron-stage-8",
        "name": "Cauldron",
        "theme": "ash",
        "width": 15,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "forest",
            "forest",
            "road",
            "mountain",
            "water",
            "water",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "mountain",
            "road",
            "forest",
            "forest"
          ],
          [
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "forest",
            "forest"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cauldron-stage-8-player-command-7-6",
            "type": "command",
            "owner": "player",
            "x": 7,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cauldron-stage-8-enemy-grunt-1-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 1
          },
          {
            "id": "cauldron-stage-8-enemy-breaker-13-1",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 1
          },
          {
            "id": "cauldron-stage-8-enemy-breaker-1-10",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 10
          },
          {
            "id": "cauldron-stage-8-enemy-grunt-13-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 10
          },
          {
            "id": "cauldron-stage-8-enemy-runner-1-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 4
          },
          {
            "id": "cauldron-stage-8-enemy-siege-gun-13-4",
            "unitTypeId": "siege-gun",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 4
          },
          {
            "id": "cauldron-stage-8-enemy-bruiser-1-7",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 7
          },
          {
            "id": "cauldron-stage-8-enemy-skyguard-13-7",
            "unitTypeId": "skyguard",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 7
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Infantry Spawns",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 2
            },
            "units": [
              {
                "id": "wave-1-breaker-0-5",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 0,
                "y": 5
              },
              {
                "id": "wave-1-grunt-14-5",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 14,
                "y": 5
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "More Infantry",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-0-6",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 0,
                "y": 6
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Runner Boss",
            "maxActivations": 2,
            "trigger": {
              "type": "player-turns-completed",
              "every": 3
            },
            "units": [
              {
                "id": "wave-3-runner-1-1",
                "unitTypeId": "runner",
                "level": 2,
                "x": 1,
                "y": 1
              },
              {
                "id": "wave-3-runner-13-10",
                "unitTypeId": "runner",
                "level": 2,
                "x": 13,
                "y": 10
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Siege Gun",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "cauldron-stage-8-enemy-siege-gun-13-4"
            },
            "units": [
              {
                "id": "wave-4-longshot-1-7",
                "unitTypeId": "longshot",
                "level": 2,
                "x": 1,
                "y": 7
              },
              {
                "id": "wave-4-siege-gun-2-9",
                "unitTypeId": "siege-gun",
                "level": 3,
                "x": 2,
                "y": 9
              }
            ]
          },
          {
            "id": "wave-5",
            "name": "Kill Counter",
            "maxActivations": 15,
            "trigger": {
              "type": "enemy-casualties",
              "every": 5
            },
            "units": [
              {
                "id": "wave-5-longshot-12-1",
                "unitTypeId": "longshot",
                "level": 5,
                "x": 12,
                "y": 1
              },
              {
                "id": "wave-5-siege-gun-3-1",
                "unitTypeId": "siege-gun",
                "level": 3,
                "x": 3,
                "y": 1
              },
              {
                "id": "wave-5-breaker-3-10",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 3,
                "y": 10
              },
              {
                "id": "wave-5-medic-12-2",
                "unitTypeId": "medic",
                "level": 5,
                "x": 12,
                "y": 2
              },
              {
                "id": "wave-5-medic-1-9",
                "unitTypeId": "medic",
                "level": 5,
                "x": 1,
                "y": 9
              }
            ]
          }
        ],
        "goal": {
          "type": "survive",
          "turnLimit": 7
        },
        "runStages": [
          8
        ],
        "stage": 8,
        "variantStage": 8
      },
      {
        "id": "cauldron-stage-9",
        "name": "Cauldron",
        "theme": "ash",
        "width": 15,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "forest",
            "forest",
            "road",
            "mountain",
            "water",
            "water",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "mountain",
            "road",
            "forest",
            "forest"
          ],
          [
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "forest",
            "forest"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cauldron-stage-9-player-command-7-6",
            "type": "command",
            "owner": "player",
            "x": 7,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cauldron-stage-9-enemy-grunt-1-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 1
          },
          {
            "id": "cauldron-stage-9-enemy-breaker-13-1",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 1
          },
          {
            "id": "cauldron-stage-9-enemy-breaker-1-10",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 10
          },
          {
            "id": "cauldron-stage-9-enemy-grunt-13-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 10
          },
          {
            "id": "cauldron-stage-9-enemy-runner-1-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 4
          },
          {
            "id": "cauldron-stage-9-enemy-siege-gun-13-4",
            "unitTypeId": "siege-gun",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 4
          },
          {
            "id": "cauldron-stage-9-enemy-bruiser-1-7",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 7
          },
          {
            "id": "cauldron-stage-9-enemy-skyguard-13-7",
            "unitTypeId": "skyguard",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 7
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Infantry Spawns",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 2
            },
            "units": [
              {
                "id": "wave-1-breaker-0-5",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 0,
                "y": 5
              },
              {
                "id": "wave-1-grunt-14-5",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 14,
                "y": 5
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "More Infantry",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-0-6",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 0,
                "y": 6
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Runner Boss",
            "maxActivations": 2,
            "trigger": {
              "type": "player-turns-completed",
              "every": 3
            },
            "units": [
              {
                "id": "wave-3-runner-1-1",
                "unitTypeId": "runner",
                "level": 2,
                "x": 1,
                "y": 1
              },
              {
                "id": "wave-3-runner-13-10",
                "unitTypeId": "runner",
                "level": 2,
                "x": 13,
                "y": 10
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Siege Gun",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "cauldron-stage-9-enemy-siege-gun-13-4"
            },
            "units": [
              {
                "id": "wave-4-longshot-1-7",
                "unitTypeId": "longshot",
                "level": 2,
                "x": 1,
                "y": 7
              },
              {
                "id": "wave-4-siege-gun-2-9",
                "unitTypeId": "siege-gun",
                "level": 3,
                "x": 2,
                "y": 9
              }
            ]
          },
          {
            "id": "wave-5",
            "name": "Kill Counter",
            "maxActivations": 15,
            "trigger": {
              "type": "enemy-casualties",
              "every": 5
            },
            "units": [
              {
                "id": "wave-5-longshot-12-1",
                "unitTypeId": "longshot",
                "level": 5,
                "x": 12,
                "y": 1
              },
              {
                "id": "wave-5-siege-gun-3-1",
                "unitTypeId": "siege-gun",
                "level": 3,
                "x": 3,
                "y": 1
              },
              {
                "id": "wave-5-breaker-3-10",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 3,
                "y": 10
              },
              {
                "id": "wave-5-medic-12-2",
                "unitTypeId": "medic",
                "level": 5,
                "x": 12,
                "y": 2
              },
              {
                "id": "wave-5-medic-1-9",
                "unitTypeId": "medic",
                "level": 5,
                "x": 1,
                "y": 9
              }
            ]
          },
          {
            "id": "wave-6",
            "name": "Gunship Boss",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 6
            },
            "units": [
              {
                "id": "wave-6-gunship-7-0",
                "unitTypeId": "gunship",
                "level": 5,
                "x": 7,
                "y": 0
              },
              {
                "id": "wave-6-gunship-7-11",
                "unitTypeId": "gunship",
                "level": 5,
                "x": 7,
                "y": 11
              }
            ]
          }
        ],
        "goal": {
          "type": "survive",
          "turnLimit": 7
        },
        "runStages": [
          9
        ],
        "stage": 9,
        "variantStage": 9
      },
      {
        "id": "cauldron-stage-10",
        "name": "Cauldron",
        "theme": "ash",
        "width": 15,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "forest",
            "forest",
            "road",
            "mountain",
            "water",
            "water",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "mountain",
            "road",
            "forest",
            "forest"
          ],
          [
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "plain",
            "road",
            "road",
            "road",
            "forest",
            "forest"
          ],
          [
            "water",
            "plain",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "road",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "plain",
            "water"
          ],
          [
            "water",
            "water",
            "road",
            "road",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "road",
            "road",
            "water",
            "water"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "road",
            "mountain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "road",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "water",
            "road",
            "road",
            "forest",
            "forest",
            "forest",
            "forest",
            "mountain"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "forest",
            "forest",
            "mountain",
            "mountain",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cauldron-stage-10-player-command-7-6",
            "type": "command",
            "owner": "player",
            "x": 7,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cauldron-stage-10-enemy-grunt-1-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 1
          },
          {
            "id": "cauldron-stage-10-enemy-breaker-13-1",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 1
          },
          {
            "id": "cauldron-stage-10-enemy-breaker-1-10",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 10
          },
          {
            "id": "cauldron-stage-10-enemy-grunt-13-10",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 10
          },
          {
            "id": "cauldron-stage-10-enemy-runner-1-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 4
          },
          {
            "id": "cauldron-stage-10-enemy-siege-gun-13-4",
            "unitTypeId": "siege-gun",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 4
          },
          {
            "id": "cauldron-stage-10-enemy-juggernaut-14-6",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 5,
            "x": 14,
            "y": 6
          },
          {
            "id": "cauldron-stage-10-enemy-bruiser-1-7",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 5,
            "x": 1,
            "y": 7
          },
          {
            "id": "cauldron-stage-10-enemy-skyguard-13-7",
            "unitTypeId": "skyguard",
            "owner": "enemy",
            "level": 5,
            "x": 13,
            "y": 7
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Infantry Spawns",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 2
            },
            "units": [
              {
                "id": "wave-1-breaker-0-5",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 0,
                "y": 5
              },
              {
                "id": "wave-1-grunt-14-5",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 14,
                "y": 5
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "More Infantry",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-0-6",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 0,
                "y": 6
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Runner Boss",
            "maxActivations": 2,
            "trigger": {
              "type": "player-turns-completed",
              "every": 3
            },
            "units": [
              {
                "id": "wave-3-runner-1-1",
                "unitTypeId": "runner",
                "level": 2,
                "x": 1,
                "y": 1
              },
              {
                "id": "wave-3-runner-13-10",
                "unitTypeId": "runner",
                "level": 2,
                "x": 13,
                "y": 10
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Siege Gun",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "cauldron-stage-10-enemy-siege-gun-13-4"
            },
            "units": [
              {
                "id": "wave-4-longshot-1-7",
                "unitTypeId": "longshot",
                "level": 2,
                "x": 1,
                "y": 7
              },
              {
                "id": "wave-4-siege-gun-2-9",
                "unitTypeId": "siege-gun",
                "level": 3,
                "x": 2,
                "y": 9
              }
            ]
          },
          {
            "id": "wave-5",
            "name": "Kill Counter",
            "maxActivations": 15,
            "trigger": {
              "type": "enemy-casualties",
              "every": 5
            },
            "units": [
              {
                "id": "wave-5-longshot-12-1",
                "unitTypeId": "longshot",
                "level": 5,
                "x": 12,
                "y": 1
              },
              {
                "id": "wave-5-siege-gun-3-1",
                "unitTypeId": "siege-gun",
                "level": 3,
                "x": 3,
                "y": 1
              },
              {
                "id": "wave-5-breaker-3-10",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 3,
                "y": 10
              },
              {
                "id": "wave-5-medic-12-2",
                "unitTypeId": "medic",
                "level": 5,
                "x": 12,
                "y": 2
              },
              {
                "id": "wave-5-medic-1-9",
                "unitTypeId": "medic",
                "level": 5,
                "x": 1,
                "y": 9
              }
            ]
          },
          {
            "id": "wave-6",
            "name": "Gunship Boss",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 6
            },
            "units": [
              {
                "id": "wave-6-gunship-7-0",
                "unitTypeId": "gunship",
                "level": 5,
                "x": 7,
                "y": 0
              },
              {
                "id": "wave-6-gunship-7-11",
                "unitTypeId": "gunship",
                "level": 5,
                "x": 7,
                "y": 11
              }
            ]
          }
        ],
        "goal": {
          "type": "survive",
          "turnLimit": 7
        },
        "runStages": [
          10
        ],
        "stage": 10,
        "variantStage": 10
      }
    ]
  },
  "./maps/cauldron/cinder-switchyard.json": {
    "format": "ash-run-map-bundle-v1",
    "id": "cinder-switchyard",
    "name": "Cinder Switchyard",
    "stages": [
      {
        "id": "cinder-switchyard-stage-1",
        "name": "Cinder Switchyard",
        "theme": "ash",
        "layout": "east-west",
        "width": 14,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "plain",
            "plain",
            "forest",
            "mountain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "mountain",
            "forest",
            "plain",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "forest",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "forest",
            "mountain",
            "plain",
            "plain"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cinder-switchyard-stage-1-player-command-1-5",
            "type": "command",
            "owner": "player",
            "x": 1,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-1-player-sector-2-6",
            "type": "sector",
            "owner": "player",
            "x": 2,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-1-neutral-hospital-5-2",
            "type": "hospital",
            "owner": "neutral",
            "x": 5,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-1-neutral-sector-5-4",
            "type": "sector",
            "owner": "neutral",
            "x": 5,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-1-neutral-sector-8-7",
            "type": "sector",
            "owner": "neutral",
            "x": 8,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-1-neutral-repair-station-8-9",
            "type": "repair-station",
            "owner": "neutral",
            "x": 8,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-1-enemy-sector-11-5",
            "type": "sector",
            "owner": "enemy",
            "x": 11,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-1-enemy-command-12-6",
            "type": "command",
            "owner": "enemy",
            "x": 12,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cinder-switchyard-stage-1-enemy-grunt-10-5",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 10,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-1-enemy-breaker-12-5",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 12,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-1-enemy-runner-10-9",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 10,
            "y": 9
          }
        ],
        "reinforcements": [],
        "playerSpawns": [
          {
            "x": 1,
            "y": 5
          },
          {
            "x": 1,
            "y": 6
          },
          {
            "x": 2,
            "y": 4
          },
          {
            "x": 2,
            "y": 5
          },
          {
            "x": 2,
            "y": 6
          },
          {
            "x": 2,
            "y": 7
          }
        ],
        "enemySpawns": [],
        "goal": {
          "type": "rout"
        },
        "runStages": [
          1
        ],
        "stage": 1,
        "variantStage": 1
      },
      {
        "id": "cinder-switchyard-stage-2",
        "name": "Cinder Switchyard",
        "theme": "ash",
        "layout": "east-west",
        "width": 14,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "plain",
            "plain",
            "forest",
            "mountain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "mountain",
            "forest",
            "plain",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "forest",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "forest",
            "mountain",
            "plain",
            "plain"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cinder-switchyard-stage-2-player-command-1-5",
            "type": "command",
            "owner": "player",
            "x": 1,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-2-player-sector-2-6",
            "type": "sector",
            "owner": "player",
            "x": 2,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-2-neutral-hospital-5-2",
            "type": "hospital",
            "owner": "neutral",
            "x": 5,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-2-neutral-sector-5-4",
            "type": "sector",
            "owner": "neutral",
            "x": 5,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-2-neutral-sector-8-7",
            "type": "sector",
            "owner": "neutral",
            "x": 8,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-2-neutral-repair-station-8-9",
            "type": "repair-station",
            "owner": "neutral",
            "x": 8,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-2-enemy-sector-11-5",
            "type": "sector",
            "owner": "enemy",
            "x": 11,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-2-enemy-command-12-6",
            "type": "command",
            "owner": "enemy",
            "x": 12,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cinder-switchyard-stage-2-enemy-grunt-10-5",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 10,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-2-enemy-breaker-12-5",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 12,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-2-enemy-longshot-11-3",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 1,
            "x": 11,
            "y": 3
          },
          {
            "id": "cinder-switchyard-stage-2-enemy-runner-10-9",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 10,
            "y": 9
          }
        ],
        "reinforcements": [],
        "playerSpawns": [
          {
            "x": 1,
            "y": 5
          },
          {
            "x": 1,
            "y": 6
          },
          {
            "x": 2,
            "y": 4
          },
          {
            "x": 2,
            "y": 5
          },
          {
            "x": 2,
            "y": 6
          },
          {
            "x": 2,
            "y": 7
          }
        ],
        "enemySpawns": [],
        "goal": {
          "type": "rout"
        },
        "runStages": [
          2
        ],
        "stage": 2,
        "variantStage": 2
      },
      {
        "id": "cinder-switchyard-stage-3",
        "name": "Cinder Switchyard",
        "theme": "ash",
        "layout": "east-west",
        "width": 14,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "plain",
            "plain",
            "forest",
            "mountain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "mountain",
            "forest",
            "plain",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "forest",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "forest",
            "mountain",
            "plain",
            "plain"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cinder-switchyard-stage-3-player-command-1-5",
            "type": "command",
            "owner": "player",
            "x": 1,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-3-player-sector-2-6",
            "type": "sector",
            "owner": "player",
            "x": 2,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-3-neutral-hospital-5-2",
            "type": "hospital",
            "owner": "neutral",
            "x": 5,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-3-neutral-sector-5-4",
            "type": "sector",
            "owner": "neutral",
            "x": 5,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-3-neutral-sector-8-7",
            "type": "sector",
            "owner": "neutral",
            "x": 8,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-3-neutral-repair-station-8-9",
            "type": "repair-station",
            "owner": "neutral",
            "x": 8,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-3-enemy-sector-11-5",
            "type": "sector",
            "owner": "enemy",
            "x": 11,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-3-enemy-command-12-6",
            "type": "command",
            "owner": "enemy",
            "x": 12,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cinder-switchyard-stage-3-enemy-grunt-10-5",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 10,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-3-enemy-breaker-12-5",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 12,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-3-enemy-longshot-11-3",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 11,
            "y": 3
          },
          {
            "id": "cinder-switchyard-stage-3-enemy-bruiser-10-6",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 1,
            "x": 10,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-3-enemy-medic-12-7",
            "unitTypeId": "medic",
            "owner": "enemy",
            "level": 2,
            "x": 12,
            "y": 7
          }
        ],
        "reinforcements": [],
        "playerSpawns": [
          {
            "x": 1,
            "y": 5
          },
          {
            "x": 1,
            "y": 6
          },
          {
            "x": 2,
            "y": 4
          },
          {
            "x": 2,
            "y": 5
          },
          {
            "x": 2,
            "y": 6
          },
          {
            "x": 2,
            "y": 7
          }
        ],
        "enemySpawns": [],
        "goal": {
          "type": "rout"
        },
        "runStages": [
          3
        ],
        "stage": 3,
        "variantStage": 3
      },
      {
        "id": "cinder-switchyard-stage-4",
        "name": "Cinder Switchyard",
        "theme": "ash",
        "layout": "east-west",
        "width": 14,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "plain",
            "plain",
            "forest",
            "mountain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "mountain",
            "forest",
            "plain",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "forest",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "forest",
            "mountain",
            "plain",
            "plain"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cinder-switchyard-stage-4-player-command-1-5",
            "type": "command",
            "owner": "player",
            "x": 1,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-4-player-sector-2-6",
            "type": "sector",
            "owner": "player",
            "x": 2,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-4-neutral-hospital-5-2",
            "type": "hospital",
            "owner": "neutral",
            "x": 5,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-4-neutral-sector-5-4",
            "type": "sector",
            "owner": "neutral",
            "x": 5,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-4-neutral-sector-8-7",
            "type": "sector",
            "owner": "neutral",
            "x": 8,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-4-neutral-repair-station-8-9",
            "type": "repair-station",
            "owner": "neutral",
            "x": 8,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-4-enemy-sector-11-5",
            "type": "sector",
            "owner": "enemy",
            "x": 11,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-4-enemy-command-12-6",
            "type": "command",
            "owner": "enemy",
            "x": 12,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cinder-switchyard-stage-4-enemy-breaker-12-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 12,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-4-enemy-longshot-11-3",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 2,
            "x": 11,
            "y": 3
          },
          {
            "id": "cinder-switchyard-stage-4-enemy-runner-10-5",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 2,
            "x": 10,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-4-enemy-bruiser-10-6",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 1,
            "x": 10,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-4-enemy-mechanic-12-7",
            "unitTypeId": "mechanic",
            "owner": "enemy",
            "level": 2,
            "x": 12,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-4-enemy-grunt-10-9",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 3,
            "x": 10,
            "y": 9
          }
        ],
        "reinforcements": [],
        "playerSpawns": [
          {
            "x": 1,
            "y": 5
          },
          {
            "x": 1,
            "y": 6
          },
          {
            "x": 2,
            "y": 4
          },
          {
            "x": 2,
            "y": 5
          },
          {
            "x": 2,
            "y": 6
          },
          {
            "x": 2,
            "y": 7
          }
        ],
        "enemySpawns": [],
        "goal": {
          "type": "rout"
        },
        "runStages": [
          4
        ],
        "stage": 4,
        "variantStage": 4
      },
      {
        "id": "cinder-switchyard-stage-5",
        "name": "Cinder Switchyard",
        "theme": "ash",
        "layout": "east-west",
        "width": 14,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "plain",
            "plain",
            "forest",
            "mountain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "mountain",
            "forest",
            "plain",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "forest",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "forest",
            "mountain",
            "plain",
            "plain"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cinder-switchyard-stage-5-player-command-1-5",
            "type": "command",
            "owner": "player",
            "x": 1,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-5-player-sector-2-6",
            "type": "sector",
            "owner": "player",
            "x": 2,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-5-neutral-hospital-5-2",
            "type": "hospital",
            "owner": "neutral",
            "x": 5,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-5-neutral-sector-5-4",
            "type": "sector",
            "owner": "neutral",
            "x": 5,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-5-neutral-sector-8-7",
            "type": "sector",
            "owner": "neutral",
            "x": 8,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-5-neutral-repair-station-8-9",
            "type": "repair-station",
            "owner": "neutral",
            "x": 8,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-5-enemy-sector-11-5",
            "type": "sector",
            "owner": "enemy",
            "x": 11,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-5-enemy-command-12-6",
            "type": "command",
            "owner": "enemy",
            "x": 12,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cinder-switchyard-stage-5-enemy-longshot-12-2",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 3,
            "x": 12,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-5-enemy-siege-gun-11-3",
            "unitTypeId": "siege-gun",
            "owner": "enemy",
            "level": 1,
            "x": 11,
            "y": 3
          },
          {
            "id": "cinder-switchyard-stage-5-enemy-breaker-10-5",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 3,
            "x": 10,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-5-enemy-bruiser-10-6",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 2,
            "x": 10,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-5-enemy-skyguard-12-7",
            "unitTypeId": "skyguard",
            "owner": "enemy",
            "level": 1,
            "x": 12,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-5-enemy-mechanic-10-9",
            "unitTypeId": "mechanic",
            "owner": "enemy",
            "level": 3,
            "x": 10,
            "y": 9
          }
        ],
        "reinforcements": [],
        "playerSpawns": [
          {
            "x": 1,
            "y": 5
          },
          {
            "x": 1,
            "y": 6
          },
          {
            "x": 2,
            "y": 4
          },
          {
            "x": 2,
            "y": 5
          },
          {
            "x": 2,
            "y": 6
          },
          {
            "x": 2,
            "y": 7
          }
        ],
        "enemySpawns": [],
        "goal": {
          "type": "rout"
        },
        "runStages": [
          5
        ],
        "stage": 5,
        "variantStage": 5
      },
      {
        "id": "cinder-switchyard-stage-6",
        "name": "Cinder Switchyard",
        "theme": "ash",
        "layout": "east-west",
        "width": 14,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "plain",
            "plain",
            "forest",
            "mountain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "mountain",
            "forest",
            "plain",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "forest",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "forest",
            "mountain",
            "plain",
            "plain"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cinder-switchyard-stage-6-player-command-1-5",
            "type": "command",
            "owner": "player",
            "x": 1,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-6-player-sector-2-6",
            "type": "sector",
            "owner": "player",
            "x": 2,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-6-neutral-hospital-5-2",
            "type": "hospital",
            "owner": "neutral",
            "x": 5,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-6-neutral-sector-5-4",
            "type": "sector",
            "owner": "neutral",
            "x": 5,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-6-neutral-sector-8-7",
            "type": "sector",
            "owner": "neutral",
            "x": 8,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-6-neutral-repair-station-8-9",
            "type": "repair-station",
            "owner": "neutral",
            "x": 8,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-6-enemy-sector-11-5",
            "type": "sector",
            "owner": "enemy",
            "x": 11,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-6-enemy-command-12-6",
            "type": "command",
            "owner": "enemy",
            "x": 12,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cinder-switchyard-stage-6-enemy-longshot-12-2",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 3,
            "x": 12,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-6-enemy-siege-gun-11-3",
            "unitTypeId": "siege-gun",
            "owner": "enemy",
            "level": 2,
            "x": 11,
            "y": 3
          },
          {
            "id": "cinder-switchyard-stage-6-enemy-runner-12-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 3,
            "x": 12,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-6-enemy-bruiser-10-6",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 2,
            "x": 10,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-6-enemy-breaker-12-7",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 3,
            "x": 12,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-6-enemy-mechanic-10-9",
            "unitTypeId": "mechanic",
            "owner": "enemy",
            "level": 3,
            "x": 10,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-6-enemy-gunship-9-5",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 1,
            "x": 9,
            "y": 5
          }
        ],
        "reinforcements": [],
        "playerSpawns": [
          {
            "x": 1,
            "y": 5
          },
          {
            "x": 1,
            "y": 6
          },
          {
            "x": 2,
            "y": 4
          },
          {
            "x": 2,
            "y": 5
          },
          {
            "x": 2,
            "y": 6
          },
          {
            "x": 2,
            "y": 7
          }
        ],
        "enemySpawns": [],
        "goal": {
          "type": "rout"
        },
        "runStages": [
          6
        ],
        "stage": 6,
        "variantStage": 6
      },
      {
        "id": "cinder-switchyard-stage-7",
        "name": "Cinder Switchyard",
        "theme": "ash",
        "layout": "east-west",
        "width": 14,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "plain",
            "plain",
            "forest",
            "mountain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "mountain",
            "forest",
            "plain",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "forest",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "forest",
            "mountain",
            "plain",
            "plain"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cinder-switchyard-stage-7-player-command-1-5",
            "type": "command",
            "owner": "player",
            "x": 1,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-7-player-sector-2-6",
            "type": "sector",
            "owner": "player",
            "x": 2,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-7-neutral-hospital-5-2",
            "type": "hospital",
            "owner": "neutral",
            "x": 5,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-7-neutral-sector-5-4",
            "type": "sector",
            "owner": "neutral",
            "x": 5,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-7-neutral-sector-8-7",
            "type": "sector",
            "owner": "neutral",
            "x": 8,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-7-neutral-repair-station-8-9",
            "type": "repair-station",
            "owner": "neutral",
            "x": 8,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-7-enemy-sector-11-5",
            "type": "sector",
            "owner": "enemy",
            "x": 11,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-7-enemy-command-12-6",
            "type": "command",
            "owner": "enemy",
            "x": 12,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cinder-switchyard-stage-7-enemy-siege-gun-12-2",
            "unitTypeId": "siege-gun",
            "owner": "enemy",
            "level": 2,
            "x": 12,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-7-enemy-longshot-11-3",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 4,
            "x": 11,
            "y": 3
          },
          {
            "id": "cinder-switchyard-stage-7-enemy-juggernaut-10-5",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 1,
            "x": 10,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-7-enemy-skyguard-10-6",
            "unitTypeId": "skyguard",
            "owner": "enemy",
            "level": 2,
            "x": 10,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-7-enemy-breaker-12-7",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 4,
            "x": 12,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-7-enemy-mechanic-10-9",
            "unitTypeId": "mechanic",
            "owner": "enemy",
            "level": 4,
            "x": 10,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-7-enemy-gunship-9-5",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 2,
            "x": 9,
            "y": 5
          }
        ],
        "reinforcements": [],
        "playerSpawns": [
          {
            "x": 1,
            "y": 5
          },
          {
            "x": 1,
            "y": 6
          },
          {
            "x": 2,
            "y": 4
          },
          {
            "x": 2,
            "y": 5
          },
          {
            "x": 2,
            "y": 6
          },
          {
            "x": 2,
            "y": 7
          }
        ],
        "enemySpawns": [],
        "goal": {
          "type": "rout"
        },
        "runStages": [
          7
        ],
        "stage": 7,
        "variantStage": 7
      },
      {
        "id": "cinder-switchyard-stage-8",
        "name": "Cinder Switchyard",
        "theme": "ash",
        "layout": "east-west",
        "width": 14,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "plain",
            "plain",
            "forest",
            "mountain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "mountain",
            "forest",
            "plain",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "forest",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "forest",
            "mountain",
            "plain",
            "plain"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cinder-switchyard-stage-8-player-command-1-5",
            "type": "command",
            "owner": "player",
            "x": 1,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-8-player-sector-2-6",
            "type": "sector",
            "owner": "player",
            "x": 2,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-8-neutral-hospital-5-2",
            "type": "hospital",
            "owner": "neutral",
            "x": 5,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-8-neutral-sector-5-4",
            "type": "sector",
            "owner": "neutral",
            "x": 5,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-8-neutral-sector-8-7",
            "type": "sector",
            "owner": "neutral",
            "x": 8,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-8-neutral-repair-station-8-9",
            "type": "repair-station",
            "owner": "neutral",
            "x": 8,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-8-enemy-sector-11-5",
            "type": "sector",
            "owner": "enemy",
            "x": 11,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-8-enemy-command-12-6",
            "type": "command",
            "owner": "enemy",
            "x": 12,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cinder-switchyard-stage-8-enemy-siege-gun-12-2",
            "unitTypeId": "siege-gun",
            "owner": "enemy",
            "level": 3,
            "x": 12,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-8-enemy-payload-11-3",
            "unitTypeId": "payload",
            "owner": "enemy",
            "level": 1,
            "x": 11,
            "y": 3
          },
          {
            "id": "cinder-switchyard-stage-8-enemy-bruiser-12-4",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 3,
            "x": 12,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-8-enemy-juggernaut-10-5",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 1,
            "x": 10,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-8-enemy-skyguard-10-6",
            "unitTypeId": "skyguard",
            "owner": "enemy",
            "level": 3,
            "x": 10,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-8-enemy-breaker-12-7",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 4,
            "x": 12,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-8-enemy-mechanic-10-9",
            "unitTypeId": "mechanic",
            "owner": "enemy",
            "level": 4,
            "x": 10,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-8-enemy-gunship-9-5",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 2,
            "x": 9,
            "y": 5
          }
        ],
        "reinforcements": [],
        "playerSpawns": [
          {
            "x": 1,
            "y": 5
          },
          {
            "x": 1,
            "y": 6
          },
          {
            "x": 2,
            "y": 4
          },
          {
            "x": 2,
            "y": 5
          },
          {
            "x": 2,
            "y": 6
          },
          {
            "x": 2,
            "y": 7
          }
        ],
        "enemySpawns": [],
        "goal": {
          "type": "rout"
        },
        "runStages": [
          8
        ],
        "stage": 8,
        "variantStage": 8
      },
      {
        "id": "cinder-switchyard-stage-9",
        "name": "Cinder Switchyard",
        "theme": "ash",
        "layout": "east-west",
        "width": 14,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "plain",
            "plain",
            "forest",
            "mountain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "mountain",
            "forest",
            "plain",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "forest",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "forest",
            "mountain",
            "plain",
            "plain"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cinder-switchyard-stage-9-player-command-1-5",
            "type": "command",
            "owner": "player",
            "x": 1,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-9-player-sector-2-6",
            "type": "sector",
            "owner": "player",
            "x": 2,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-9-neutral-hospital-5-2",
            "type": "hospital",
            "owner": "neutral",
            "x": 5,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-9-neutral-sector-5-4",
            "type": "sector",
            "owner": "neutral",
            "x": 5,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-9-neutral-sector-8-7",
            "type": "sector",
            "owner": "neutral",
            "x": 8,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-9-neutral-repair-station-8-9",
            "type": "repair-station",
            "owner": "neutral",
            "x": 8,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-9-enemy-sector-11-5",
            "type": "sector",
            "owner": "enemy",
            "x": 11,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-9-enemy-command-12-6",
            "type": "command",
            "owner": "enemy",
            "x": 12,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cinder-switchyard-stage-9-enemy-siege-gun-12-2",
            "unitTypeId": "siege-gun",
            "owner": "enemy",
            "level": 3,
            "x": 12,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-9-enemy-payload-11-3",
            "unitTypeId": "payload",
            "owner": "enemy",
            "level": 2,
            "x": 11,
            "y": 3
          },
          {
            "id": "cinder-switchyard-stage-9-enemy-runner-10-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 4,
            "x": 10,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-9-enemy-bruiser-12-4",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 3,
            "x": 12,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-9-enemy-juggernaut-10-5",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 2,
            "x": 10,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-9-enemy-skyguard-10-6",
            "unitTypeId": "skyguard",
            "owner": "enemy",
            "level": 3,
            "x": 10,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-9-enemy-longshot-12-7",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 5,
            "x": 12,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-9-enemy-mechanic-10-9",
            "unitTypeId": "mechanic",
            "owner": "enemy",
            "level": 5,
            "x": 10,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-9-enemy-gunship-9-5",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 9,
            "y": 5
          }
        ],
        "reinforcements": [],
        "playerSpawns": [
          {
            "x": 1,
            "y": 5
          },
          {
            "x": 1,
            "y": 6
          },
          {
            "x": 2,
            "y": 4
          },
          {
            "x": 2,
            "y": 5
          },
          {
            "x": 2,
            "y": 6
          },
          {
            "x": 2,
            "y": 7
          }
        ],
        "enemySpawns": [],
        "goal": {
          "type": "rout"
        },
        "runStages": [
          9
        ],
        "stage": 9,
        "variantStage": 9
      },
      {
        "id": "cinder-switchyard-stage-10",
        "name": "Cinder Switchyard",
        "theme": "ash",
        "layout": "east-west",
        "width": 14,
        "height": 12,
        "tiles": [
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "plain",
            "plain",
            "forest",
            "mountain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "mountain",
            "forest",
            "plain",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "forest",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "forest",
            "mountain",
            "plain",
            "plain"
          ],
          [
            "plain",
            "forest",
            "plain",
            "mountain",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "mountain",
            "plain",
            "forest",
            "plain"
          ],
          [
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "forest",
            "forest",
            "plain",
            "plain",
            "forest",
            "water",
            "water",
            "forest",
            "plain",
            "plain",
            "forest",
            "forest",
            "plain"
          ],
          [
            "mountain",
            "mountain",
            "forest",
            "forest",
            "plain",
            "plain",
            "water",
            "water",
            "plain",
            "plain",
            "forest",
            "forest",
            "mountain",
            "mountain"
          ]
        ],
        "buildings": [
          {
            "id": "cinder-switchyard-stage-10-player-command-1-5",
            "type": "command",
            "owner": "player",
            "x": 1,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-10-player-sector-2-6",
            "type": "sector",
            "owner": "player",
            "x": 2,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-10-neutral-hospital-5-2",
            "type": "hospital",
            "owner": "neutral",
            "x": 5,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-10-neutral-sector-5-4",
            "type": "sector",
            "owner": "neutral",
            "x": 5,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-10-neutral-sector-8-7",
            "type": "sector",
            "owner": "neutral",
            "x": 8,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-10-neutral-repair-station-8-9",
            "type": "repair-station",
            "owner": "neutral",
            "x": 8,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-10-enemy-sector-11-5",
            "type": "sector",
            "owner": "enemy",
            "x": 11,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-10-enemy-command-12-6",
            "type": "command",
            "owner": "enemy",
            "x": 12,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "cinder-switchyard-stage-10-enemy-siege-gun-12-2",
            "unitTypeId": "siege-gun",
            "owner": "enemy",
            "level": 4,
            "x": 12,
            "y": 2
          },
          {
            "id": "cinder-switchyard-stage-10-enemy-payload-11-3",
            "unitTypeId": "payload",
            "owner": "enemy",
            "level": 2,
            "x": 11,
            "y": 3
          },
          {
            "id": "cinder-switchyard-stage-10-enemy-runner-10-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 4,
            "x": 10,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-10-enemy-bruiser-12-4",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 4,
            "x": 12,
            "y": 4
          },
          {
            "id": "cinder-switchyard-stage-10-enemy-juggernaut-10-5",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 2,
            "x": 10,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-10-enemy-skyguard-10-6",
            "unitTypeId": "skyguard",
            "owner": "enemy",
            "level": 4,
            "x": 10,
            "y": 6
          },
          {
            "id": "cinder-switchyard-stage-10-enemy-breaker-12-7",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 5,
            "x": 12,
            "y": 7
          },
          {
            "id": "cinder-switchyard-stage-10-enemy-mechanic-10-9",
            "unitTypeId": "mechanic",
            "owner": "enemy",
            "level": 5,
            "x": 10,
            "y": 9
          },
          {
            "id": "cinder-switchyard-stage-10-enemy-gunship-9-5",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 9,
            "y": 5
          },
          {
            "id": "cinder-switchyard-stage-10-enemy-siege-gun-9-6",
            "unitTypeId": "siege-gun",
            "owner": "enemy",
            "level": 4,
            "x": 9,
            "y": 6
          }
        ],
        "reinforcements": [],
        "playerSpawns": [
          {
            "x": 1,
            "y": 5
          },
          {
            "x": 1,
            "y": 6
          },
          {
            "x": 2,
            "y": 4
          },
          {
            "x": 2,
            "y": 5
          },
          {
            "x": 2,
            "y": 6
          },
          {
            "x": 2,
            "y": 7
          }
        ],
        "enemySpawns": [],
        "goal": {
          "type": "rout"
        },
        "runStages": [
          10
        ],
        "stage": 10,
        "variantStage": 10
      }
    ]
  },
  "./maps/cauldron/mereopolis.json": {
    "format": "ash-run-map-bundle-v1",
    "id": "mereopolis",
    "name": "Mereopolis",
    "stages": [
      {
        "id": "mereopolis-stage-1",
        "name": "Mereopolis",
        "theme": "ash",
        "width": 18,
        "height": 10,
        "tiles": [
          [
            "plain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "road",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "water",
            "water",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "plain",
            "plain",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "road",
            "water",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "mereopolis-stage-1-player-barracks-13-3",
            "type": "barracks",
            "owner": "player",
            "x": 13,
            "y": 3
          },
          {
            "id": "mereopolis-stage-1-player-repair-station-12-4",
            "type": "repair-station",
            "owner": "player",
            "x": 12,
            "y": 4
          },
          {
            "id": "mereopolis-stage-1-player-airfield-14-4",
            "type": "airfield",
            "owner": "player",
            "x": 14,
            "y": 4
          },
          {
            "id": "mereopolis-stage-1-player-hospital-12-5",
            "type": "hospital",
            "owner": "player",
            "x": 12,
            "y": 5
          },
          {
            "id": "mereopolis-stage-1-player-motor-pool-13-5",
            "type": "motor-pool",
            "owner": "player",
            "x": 13,
            "y": 5
          },
          {
            "id": "mereopolis-stage-1-player-sector-14-5",
            "type": "sector",
            "owner": "player",
            "x": 14,
            "y": 5
          },
          {
            "id": "mereopolis-stage-1-player-command-13-6",
            "type": "command",
            "owner": "player",
            "x": 13,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "mereopolis-stage-1-enemy-grunt-3-0",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 0
          },
          {
            "id": "mereopolis-stage-1-enemy-bruiser-4-0",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 1,
            "x": 4,
            "y": 0
          },
          {
            "id": "mereopolis-stage-1-enemy-grunt-2-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 1
          },
          {
            "id": "mereopolis-stage-1-enemy-breaker-3-1",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 1
          },
          {
            "id": "mereopolis-stage-1-enemy-medic-2-2",
            "unitTypeId": "medic",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 2
          },
          {
            "id": "mereopolis-stage-1-enemy-longshot-3-2",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 2
          },
          {
            "id": "mereopolis-stage-1-enemy-breaker-4-3",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 4,
            "y": 3
          },
          {
            "id": "mereopolis-stage-1-enemy-runner-3-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 4
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 13,
            "y": 6
          },
          "turnLimit": 5
        },
        "runStages": [
          1
        ],
        "stage": 1,
        "variantStage": 1
      },
      {
        "id": "mereopolis-stage-2",
        "name": "Mereopolis",
        "theme": "ash",
        "width": 18,
        "height": 10,
        "tiles": [
          [
            "plain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "road",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "water",
            "water",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "plain",
            "plain",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "road",
            "water",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "mereopolis-stage-2-player-barracks-13-3",
            "type": "barracks",
            "owner": "player",
            "x": 13,
            "y": 3
          },
          {
            "id": "mereopolis-stage-2-player-repair-station-12-4",
            "type": "repair-station",
            "owner": "player",
            "x": 12,
            "y": 4
          },
          {
            "id": "mereopolis-stage-2-player-airfield-14-4",
            "type": "airfield",
            "owner": "player",
            "x": 14,
            "y": 4
          },
          {
            "id": "mereopolis-stage-2-player-hospital-12-5",
            "type": "hospital",
            "owner": "player",
            "x": 12,
            "y": 5
          },
          {
            "id": "mereopolis-stage-2-player-motor-pool-13-5",
            "type": "motor-pool",
            "owner": "player",
            "x": 13,
            "y": 5
          },
          {
            "id": "mereopolis-stage-2-player-sector-14-5",
            "type": "sector",
            "owner": "player",
            "x": 14,
            "y": 5
          },
          {
            "id": "mereopolis-stage-2-player-command-13-6",
            "type": "command",
            "owner": "player",
            "x": 13,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "mereopolis-stage-2-enemy-grunt-3-0",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 0
          },
          {
            "id": "mereopolis-stage-2-enemy-bruiser-4-0",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 1,
            "x": 4,
            "y": 0
          },
          {
            "id": "mereopolis-stage-2-enemy-grunt-2-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 1
          },
          {
            "id": "mereopolis-stage-2-enemy-breaker-3-1",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 1
          },
          {
            "id": "mereopolis-stage-2-enemy-medic-2-2",
            "unitTypeId": "medic",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 2
          },
          {
            "id": "mereopolis-stage-2-enemy-longshot-3-2",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 2
          },
          {
            "id": "mereopolis-stage-2-enemy-breaker-4-3",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 4,
            "y": 3
          },
          {
            "id": "mereopolis-stage-2-enemy-runner-3-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 4
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "enemy-casualties",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-breaker-3-0",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 3,
                "y": 0
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-2-1",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 2,
                "y": 1
              },
              {
                "id": "wave-2-breaker-2-2",
                "unitTypeId": "breaker",
                "level": 2,
                "x": 2,
                "y": 2
              },
              {
                "id": "wave-2-grunt-3-2",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 3,
                "y": 2
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 13,
            "y": 6
          },
          "turnLimit": 6
        },
        "runStages": [
          2
        ],
        "stage": 2,
        "variantStage": 2
      },
      {
        "id": "mereopolis-stage-3",
        "name": "Mereopolis",
        "theme": "ash",
        "width": 18,
        "height": 10,
        "tiles": [
          [
            "plain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "road",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "water",
            "water",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "plain",
            "plain",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "road",
            "water",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "mereopolis-stage-3-player-barracks-13-3",
            "type": "barracks",
            "owner": "player",
            "x": 13,
            "y": 3
          },
          {
            "id": "mereopolis-stage-3-player-repair-station-12-4",
            "type": "repair-station",
            "owner": "player",
            "x": 12,
            "y": 4
          },
          {
            "id": "mereopolis-stage-3-player-airfield-14-4",
            "type": "airfield",
            "owner": "player",
            "x": 14,
            "y": 4
          },
          {
            "id": "mereopolis-stage-3-player-hospital-12-5",
            "type": "hospital",
            "owner": "player",
            "x": 12,
            "y": 5
          },
          {
            "id": "mereopolis-stage-3-player-motor-pool-13-5",
            "type": "motor-pool",
            "owner": "player",
            "x": 13,
            "y": 5
          },
          {
            "id": "mereopolis-stage-3-player-sector-14-5",
            "type": "sector",
            "owner": "player",
            "x": 14,
            "y": 5
          },
          {
            "id": "mereopolis-stage-3-player-command-13-6",
            "type": "command",
            "owner": "player",
            "x": 13,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "mereopolis-stage-3-enemy-grunt-3-0",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 0
          },
          {
            "id": "mereopolis-stage-3-enemy-bruiser-4-0",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 1,
            "x": 4,
            "y": 0
          },
          {
            "id": "mereopolis-stage-3-enemy-grunt-2-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 1
          },
          {
            "id": "mereopolis-stage-3-enemy-breaker-3-1",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 1
          },
          {
            "id": "mereopolis-stage-3-enemy-medic-2-2",
            "unitTypeId": "medic",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 2
          },
          {
            "id": "mereopolis-stage-3-enemy-longshot-3-2",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 2
          },
          {
            "id": "mereopolis-stage-3-enemy-breaker-4-3",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 4,
            "y": 3
          },
          {
            "id": "mereopolis-stage-3-enemy-runner-3-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 4
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "enemy-casualties",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-breaker-3-0",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 3,
                "y": 0
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-2-1",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 2,
                "y": 1
              },
              {
                "id": "wave-2-breaker-2-2",
                "unitTypeId": "breaker",
                "level": 2,
                "x": 2,
                "y": 2
              },
              {
                "id": "wave-2-grunt-3-2",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 3,
                "y": 2
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 13,
            "y": 6
          },
          "turnLimit": 6
        },
        "runStages": [
          3
        ],
        "stage": 3,
        "variantStage": 3
      },
      {
        "id": "mereopolis-stage-4",
        "name": "Mereopolis",
        "theme": "ash",
        "width": 18,
        "height": 10,
        "tiles": [
          [
            "plain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "road",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "water",
            "water",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "plain",
            "plain",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "road",
            "water",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "mereopolis-stage-4-player-barracks-13-3",
            "type": "barracks",
            "owner": "player",
            "x": 13,
            "y": 3
          },
          {
            "id": "mereopolis-stage-4-player-repair-station-12-4",
            "type": "repair-station",
            "owner": "player",
            "x": 12,
            "y": 4
          },
          {
            "id": "mereopolis-stage-4-player-airfield-14-4",
            "type": "airfield",
            "owner": "player",
            "x": 14,
            "y": 4
          },
          {
            "id": "mereopolis-stage-4-player-hospital-12-5",
            "type": "hospital",
            "owner": "player",
            "x": 12,
            "y": 5
          },
          {
            "id": "mereopolis-stage-4-player-motor-pool-13-5",
            "type": "motor-pool",
            "owner": "player",
            "x": 13,
            "y": 5
          },
          {
            "id": "mereopolis-stage-4-player-sector-14-5",
            "type": "sector",
            "owner": "player",
            "x": 14,
            "y": 5
          },
          {
            "id": "mereopolis-stage-4-player-command-13-6",
            "type": "command",
            "owner": "player",
            "x": 13,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "mereopolis-stage-4-enemy-grunt-3-0",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 0
          },
          {
            "id": "mereopolis-stage-4-enemy-bruiser-4-0",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 1,
            "x": 4,
            "y": 0
          },
          {
            "id": "mereopolis-stage-4-enemy-grunt-2-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 1
          },
          {
            "id": "mereopolis-stage-4-enemy-breaker-3-1",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 1
          },
          {
            "id": "mereopolis-stage-4-enemy-medic-2-2",
            "unitTypeId": "medic",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 2
          },
          {
            "id": "mereopolis-stage-4-enemy-longshot-3-2",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 2
          },
          {
            "id": "mereopolis-stage-4-enemy-breaker-4-3",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 4,
            "y": 3
          },
          {
            "id": "mereopolis-stage-4-enemy-runner-3-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 4
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "enemy-casualties",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-breaker-3-0",
                "unitTypeId": "breaker",
                "level": 1,
                "x": 3,
                "y": 0
              },
              {
                "id": "wave-1-grunt-3-3",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 3,
                "y": 3
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-2-1",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 2,
                "y": 1
              },
              {
                "id": "wave-2-breaker-2-2",
                "unitTypeId": "breaker",
                "level": 2,
                "x": 2,
                "y": 2
              },
              {
                "id": "wave-2-grunt-3-2",
                "unitTypeId": "grunt",
                "level": 1,
                "x": 3,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "mereopolis-stage-4-enemy-bruiser-4-0"
            },
            "units": [
              {
                "id": "wave-3-juggernaut-3-3",
                "unitTypeId": "juggernaut",
                "level": 2,
                "x": 3,
                "y": 3
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 13,
            "y": 6
          },
          "turnLimit": 6
        },
        "runStages": [
          4
        ],
        "stage": 4,
        "variantStage": 4
      },
      {
        "id": "mereopolis-stage-5",
        "name": "Mereopolis",
        "theme": "ash",
        "width": 18,
        "height": 10,
        "tiles": [
          [
            "plain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "road",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "water",
            "water",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "plain",
            "plain",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "road",
            "water",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "mereopolis-stage-5-player-barracks-13-3",
            "type": "barracks",
            "owner": "player",
            "x": 13,
            "y": 3
          },
          {
            "id": "mereopolis-stage-5-player-repair-station-12-4",
            "type": "repair-station",
            "owner": "player",
            "x": 12,
            "y": 4
          },
          {
            "id": "mereopolis-stage-5-player-airfield-14-4",
            "type": "airfield",
            "owner": "player",
            "x": 14,
            "y": 4
          },
          {
            "id": "mereopolis-stage-5-player-hospital-12-5",
            "type": "hospital",
            "owner": "player",
            "x": 12,
            "y": 5
          },
          {
            "id": "mereopolis-stage-5-player-motor-pool-13-5",
            "type": "motor-pool",
            "owner": "player",
            "x": 13,
            "y": 5
          },
          {
            "id": "mereopolis-stage-5-player-sector-14-5",
            "type": "sector",
            "owner": "player",
            "x": 14,
            "y": 5
          },
          {
            "id": "mereopolis-stage-5-player-command-13-6",
            "type": "command",
            "owner": "player",
            "x": 13,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "mereopolis-stage-5-enemy-gunship-1-0",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 0
          },
          {
            "id": "mereopolis-stage-5-enemy-breaker-3-0",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 3,
            "y": 0
          },
          {
            "id": "mereopolis-stage-5-enemy-bruiser-4-0",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 2,
            "x": 4,
            "y": 0
          },
          {
            "id": "mereopolis-stage-5-enemy-breaker-2-1",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 1
          },
          {
            "id": "mereopolis-stage-5-enemy-grunt-3-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 3,
            "y": 1
          },
          {
            "id": "mereopolis-stage-5-enemy-grunt-2-2",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 2
          },
          {
            "id": "mereopolis-stage-5-enemy-juggernaut-3-4",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 4
          },
          {
            "id": "mereopolis-stage-5-enemy-runner-4-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 4,
            "y": 4
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-grunt-3-1",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 3,
                "y": 1
              },
              {
                "id": "wave-1-breaker-3-2",
                "unitTypeId": "breaker",
                "level": 2,
                "x": 3,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "enemy-casualties",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-2-0",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 2,
                "y": 0
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "mereopolis-stage-5-enemy-gunship-1-0"
            },
            "units": [
              {
                "id": "wave-3-carrier-1-1",
                "unitTypeId": "carrier",
                "level": 2,
                "x": 1,
                "y": 1
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "mereopolis-stage-5-enemy-juggernaut-3-4"
            },
            "units": [
              {
                "id": "wave-4-grunt-3-2",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 3,
                "y": 2
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 13,
            "y": 6
          },
          "turnLimit": 7
        },
        "runStages": [
          5
        ],
        "stage": 5,
        "variantStage": 5
      },
      {
        "id": "mereopolis-stage-6",
        "name": "Mereopolis",
        "theme": "ash",
        "width": 18,
        "height": 10,
        "tiles": [
          [
            "plain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "road",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "water",
            "water",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "plain",
            "plain",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "road",
            "water",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "mereopolis-stage-6-player-barracks-13-3",
            "type": "barracks",
            "owner": "player",
            "x": 13,
            "y": 3
          },
          {
            "id": "mereopolis-stage-6-player-repair-station-12-4",
            "type": "repair-station",
            "owner": "player",
            "x": 12,
            "y": 4
          },
          {
            "id": "mereopolis-stage-6-player-airfield-14-4",
            "type": "airfield",
            "owner": "player",
            "x": 14,
            "y": 4
          },
          {
            "id": "mereopolis-stage-6-player-hospital-12-5",
            "type": "hospital",
            "owner": "player",
            "x": 12,
            "y": 5
          },
          {
            "id": "mereopolis-stage-6-player-motor-pool-13-5",
            "type": "motor-pool",
            "owner": "player",
            "x": 13,
            "y": 5
          },
          {
            "id": "mereopolis-stage-6-player-sector-14-5",
            "type": "sector",
            "owner": "player",
            "x": 14,
            "y": 5
          },
          {
            "id": "mereopolis-stage-6-player-command-13-6",
            "type": "command",
            "owner": "player",
            "x": 13,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "mereopolis-stage-6-enemy-gunship-1-0",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 1,
            "x": 1,
            "y": 0
          },
          {
            "id": "mereopolis-stage-6-enemy-breaker-3-0",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 2,
            "x": 3,
            "y": 0
          },
          {
            "id": "mereopolis-stage-6-enemy-bruiser-4-0",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 2,
            "x": 4,
            "y": 0
          },
          {
            "id": "mereopolis-stage-6-enemy-breaker-2-1",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 1
          },
          {
            "id": "mereopolis-stage-6-enemy-grunt-3-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 2,
            "x": 3,
            "y": 1
          },
          {
            "id": "mereopolis-stage-6-enemy-grunt-2-2",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 1,
            "x": 2,
            "y": 2
          },
          {
            "id": "mereopolis-stage-6-enemy-juggernaut-3-4",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 1,
            "x": 3,
            "y": 4
          },
          {
            "id": "mereopolis-stage-6-enemy-runner-4-4",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 1,
            "x": 4,
            "y": 4
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-grunt-3-1",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 3,
                "y": 1
              },
              {
                "id": "wave-1-breaker-3-2",
                "unitTypeId": "breaker",
                "level": 2,
                "x": 3,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "enemy-casualties",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-grunt-2-0",
                "unitTypeId": "grunt",
                "level": 2,
                "x": 2,
                "y": 0
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "mereopolis-stage-6-enemy-gunship-1-0"
            },
            "units": [
              {
                "id": "wave-3-carrier-1-1",
                "unitTypeId": "carrier",
                "level": 2,
                "x": 1,
                "y": 1
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "mereopolis-stage-6-enemy-juggernaut-3-4"
            },
            "units": [
              {
                "id": "wave-4-grunt-3-2",
                "unitTypeId": "grunt",
                "level": 4,
                "x": 3,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-5",
            "name": "Wave 5",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-5-breaker-3-2",
                "unitTypeId": "breaker",
                "level": 4,
                "x": 3,
                "y": 2
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 13,
            "y": 6
          },
          "turnLimit": 7
        },
        "runStages": [
          6
        ],
        "stage": 6,
        "variantStage": 6
      },
      {
        "id": "mereopolis-stage-7",
        "name": "Mereopolis",
        "theme": "ash",
        "width": 18,
        "height": 10,
        "tiles": [
          [
            "plain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "road",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "water",
            "water",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "plain",
            "plain",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "road",
            "water",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "mereopolis-stage-7-player-barracks-13-3",
            "type": "barracks",
            "owner": "player",
            "x": 13,
            "y": 3
          },
          {
            "id": "mereopolis-stage-7-player-repair-station-12-4",
            "type": "repair-station",
            "owner": "player",
            "x": 12,
            "y": 4
          },
          {
            "id": "mereopolis-stage-7-player-airfield-14-4",
            "type": "airfield",
            "owner": "player",
            "x": 14,
            "y": 4
          },
          {
            "id": "mereopolis-stage-7-player-hospital-12-5",
            "type": "hospital",
            "owner": "player",
            "x": 12,
            "y": 5
          },
          {
            "id": "mereopolis-stage-7-player-motor-pool-13-5",
            "type": "motor-pool",
            "owner": "player",
            "x": 13,
            "y": 5
          },
          {
            "id": "mereopolis-stage-7-player-sector-14-5",
            "type": "sector",
            "owner": "player",
            "x": 14,
            "y": 5
          },
          {
            "id": "mereopolis-stage-7-player-command-13-6",
            "type": "command",
            "owner": "player",
            "x": 13,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "mereopolis-stage-7-enemy-gunship-1-0",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 1,
            "y": 0
          },
          {
            "id": "mereopolis-stage-7-enemy-juggernaut-3-0",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 3,
            "x": 3,
            "y": 0
          },
          {
            "id": "mereopolis-stage-7-enemy-grunt-2-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 3,
            "x": 2,
            "y": 1
          },
          {
            "id": "mereopolis-stage-7-enemy-grunt-3-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 4,
            "x": 3,
            "y": 1
          },
          {
            "id": "mereopolis-stage-7-enemy-gunship-1-2",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 1,
            "y": 2
          },
          {
            "id": "mereopolis-stage-7-enemy-breaker-2-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 3,
            "x": 2,
            "y": 2
          },
          {
            "id": "mereopolis-stage-7-enemy-runner-3-3",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 3,
            "x": 3,
            "y": 3
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-breaker-2-2",
                "unitTypeId": "breaker",
                "level": 5,
                "x": 2,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "enemy-casualties",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-longshot-2-1",
                "unitTypeId": "longshot",
                "level": 4,
                "x": 2,
                "y": 1
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "mereopolis-stage-7-enemy-juggernaut-3-0"
            },
            "units": [
              {
                "id": "wave-3-juggernaut-3-0",
                "unitTypeId": "juggernaut",
                "level": 5,
                "x": 3,
                "y": 0
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-4-medic-2-2",
                "unitTypeId": "medic",
                "level": 5,
                "x": 2,
                "y": 2
              },
              {
                "id": "wave-4-breaker-3-2",
                "unitTypeId": "breaker",
                "level": 5,
                "x": 3,
                "y": 2
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 13,
            "y": 6
          },
          "turnLimit": 7
        },
        "runStages": [
          7
        ],
        "stage": 7,
        "variantStage": 7
      },
      {
        "id": "mereopolis-stage-8",
        "name": "Mereopolis",
        "theme": "ash",
        "width": 18,
        "height": 10,
        "tiles": [
          [
            "plain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "road",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "water",
            "water",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "plain",
            "plain",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "road",
            "water",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "mereopolis-stage-8-player-barracks-13-3",
            "type": "barracks",
            "owner": "player",
            "x": 13,
            "y": 3
          },
          {
            "id": "mereopolis-stage-8-player-repair-station-12-4",
            "type": "repair-station",
            "owner": "player",
            "x": 12,
            "y": 4
          },
          {
            "id": "mereopolis-stage-8-player-airfield-14-4",
            "type": "airfield",
            "owner": "player",
            "x": 14,
            "y": 4
          },
          {
            "id": "mereopolis-stage-8-player-hospital-12-5",
            "type": "hospital",
            "owner": "player",
            "x": 12,
            "y": 5
          },
          {
            "id": "mereopolis-stage-8-player-motor-pool-13-5",
            "type": "motor-pool",
            "owner": "player",
            "x": 13,
            "y": 5
          },
          {
            "id": "mereopolis-stage-8-player-sector-14-5",
            "type": "sector",
            "owner": "player",
            "x": 14,
            "y": 5
          },
          {
            "id": "mereopolis-stage-8-player-command-13-6",
            "type": "command",
            "owner": "player",
            "x": 13,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "mereopolis-stage-8-enemy-gunship-1-0",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 1,
            "y": 0
          },
          {
            "id": "mereopolis-stage-8-enemy-juggernaut-3-0",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 3,
            "x": 3,
            "y": 0
          },
          {
            "id": "mereopolis-stage-8-enemy-grunt-2-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 3,
            "x": 2,
            "y": 1
          },
          {
            "id": "mereopolis-stage-8-enemy-grunt-3-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 4,
            "x": 3,
            "y": 1
          },
          {
            "id": "mereopolis-stage-8-enemy-gunship-1-2",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 3,
            "x": 1,
            "y": 2
          },
          {
            "id": "mereopolis-stage-8-enemy-breaker-2-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 3,
            "x": 2,
            "y": 2
          },
          {
            "id": "mereopolis-stage-8-enemy-runner-3-3",
            "unitTypeId": "runner",
            "owner": "enemy",
            "level": 3,
            "x": 3,
            "y": 3
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-breaker-2-2",
                "unitTypeId": "breaker",
                "level": 5,
                "x": 2,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "enemy-casualties",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-longshot-2-1",
                "unitTypeId": "longshot",
                "level": 4,
                "x": 2,
                "y": 1
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "mereopolis-stage-8-enemy-juggernaut-3-0"
            },
            "units": [
              {
                "id": "wave-3-juggernaut-3-0",
                "unitTypeId": "juggernaut",
                "level": 5,
                "x": 3,
                "y": 0
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-4-medic-2-2",
                "unitTypeId": "medic",
                "level": 5,
                "x": 2,
                "y": 2
              },
              {
                "id": "wave-4-breaker-3-2",
                "unitTypeId": "breaker",
                "level": 5,
                "x": 3,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-5",
            "name": "Wave 5: Boss Grunt",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 2
            },
            "units": [
              {
                "id": "wave-5-medic-3-1",
                "unitTypeId": "medic",
                "level": 7,
                "x": 3,
                "y": 1
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 13,
            "y": 6
          },
          "turnLimit": 7
        },
        "runStages": [
          8
        ],
        "stage": 8,
        "variantStage": 8
      },
      {
        "id": "mereopolis-stage-9",
        "name": "Mereopolis",
        "theme": "ash",
        "width": 18,
        "height": 10,
        "tiles": [
          [
            "plain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "road",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "water",
            "water",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "plain",
            "plain",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "road",
            "water",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "mereopolis-stage-9-player-barracks-13-3",
            "type": "barracks",
            "owner": "player",
            "x": 13,
            "y": 3
          },
          {
            "id": "mereopolis-stage-9-player-repair-station-12-4",
            "type": "repair-station",
            "owner": "player",
            "x": 12,
            "y": 4
          },
          {
            "id": "mereopolis-stage-9-player-airfield-14-4",
            "type": "airfield",
            "owner": "player",
            "x": 14,
            "y": 4
          },
          {
            "id": "mereopolis-stage-9-player-hospital-12-5",
            "type": "hospital",
            "owner": "player",
            "x": 12,
            "y": 5
          },
          {
            "id": "mereopolis-stage-9-player-motor-pool-13-5",
            "type": "motor-pool",
            "owner": "player",
            "x": 13,
            "y": 5
          },
          {
            "id": "mereopolis-stage-9-player-sector-14-5",
            "type": "sector",
            "owner": "player",
            "x": 14,
            "y": 5
          },
          {
            "id": "mereopolis-stage-9-player-command-13-6",
            "type": "command",
            "owner": "player",
            "x": 13,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "mereopolis-stage-9-enemy-breaker-3-0",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 6,
            "x": 3,
            "y": 0
          },
          {
            "id": "mereopolis-stage-9-enemy-bruiser-4-0",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 6,
            "x": 4,
            "y": 0
          },
          {
            "id": "mereopolis-stage-9-enemy-juggernaut-5-0",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 6,
            "x": 5,
            "y": 0
          },
          {
            "id": "mereopolis-stage-9-enemy-gunship-1-1",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 6,
            "x": 1,
            "y": 1
          },
          {
            "id": "mereopolis-stage-9-enemy-grunt-3-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 6,
            "x": 3,
            "y": 1
          },
          {
            "id": "mereopolis-stage-9-enemy-longshot-5-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 6,
            "x": 5,
            "y": 1
          },
          {
            "id": "mereopolis-stage-9-enemy-breaker-3-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 6,
            "x": 3,
            "y": 2
          },
          {
            "id": "mereopolis-stage-9-enemy-grunt-3-3",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 6,
            "x": 3,
            "y": 3
          },
          {
            "id": "mereopolis-stage-9-enemy-bruiser-3-4",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 6,
            "x": 3,
            "y": 4
          },
          {
            "id": "mereopolis-stage-9-enemy-juggernaut-3-5",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 6,
            "x": 3,
            "y": 5
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-longshot-2-1",
                "unitTypeId": "longshot",
                "level": 6,
                "x": 2,
                "y": 1
              },
              {
                "id": "wave-1-breaker-3-1",
                "unitTypeId": "breaker",
                "level": 6,
                "x": 3,
                "y": 1
              },
              {
                "id": "wave-1-medic-2-2",
                "unitTypeId": "medic",
                "level": 6,
                "x": 2,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "enemy-casualties",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-breaker-3-1",
                "unitTypeId": "breaker",
                "level": 7,
                "x": 3,
                "y": 1
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "mereopolis-stage-9-enemy-gunship-1-1"
            },
            "units": [
              {
                "id": "wave-3-interceptor-2-0",
                "unitTypeId": "interceptor",
                "level": 7,
                "x": 2,
                "y": 0
              },
              {
                "id": "wave-3-payload-1-2",
                "unitTypeId": "payload",
                "level": 5,
                "x": 1,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "enemy-casualties",
              "every": 1
            },
            "units": [
              {
                "id": "wave-4-grunt-3-1",
                "unitTypeId": "grunt",
                "level": 7,
                "x": 3,
                "y": 1
              }
            ]
          },
          {
            "id": "wave-5",
            "name": "Wave 5: Boss Breaker",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-5-breaker-3-2",
                "unitTypeId": "breaker",
                "level": 8,
                "x": 3,
                "y": 2
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 13,
            "y": 6
          },
          "turnLimit": 8
        },
        "runStages": [
          9
        ],
        "stage": 9,
        "variantStage": 9
      },
      {
        "id": "mereopolis-stage-10",
        "name": "Mereopolis",
        "theme": "ash",
        "width": 18,
        "height": 10,
        "tiles": [
          [
            "plain",
            "mountain",
            "mountain",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "plain",
            "plain",
            "plain",
            "road",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "mountain",
            "mountain",
            "mountain",
            "mountain",
            "water",
            "water",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "mountain",
            "mountain",
            "water",
            "plain",
            "plain",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "mountain",
            "road",
            "plain",
            "plain",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "water",
            "road"
          ],
          [
            "plain",
            "plain",
            "plain",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "road",
            "plain",
            "water",
            "water",
            "road",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "road",
            "road",
            "road",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "road",
            "water",
            "plain",
            "plain",
            "plain",
            "plain",
            "road"
          ],
          [
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "forest",
            "water",
            "water",
            "water",
            "water",
            "water",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road",
            "road"
          ]
        ],
        "buildings": [
          {
            "id": "mereopolis-stage-10-player-barracks-13-3",
            "type": "barracks",
            "owner": "player",
            "x": 13,
            "y": 3
          },
          {
            "id": "mereopolis-stage-10-player-repair-station-12-4",
            "type": "repair-station",
            "owner": "player",
            "x": 12,
            "y": 4
          },
          {
            "id": "mereopolis-stage-10-player-airfield-14-4",
            "type": "airfield",
            "owner": "player",
            "x": 14,
            "y": 4
          },
          {
            "id": "mereopolis-stage-10-player-hospital-12-5",
            "type": "hospital",
            "owner": "player",
            "x": 12,
            "y": 5
          },
          {
            "id": "mereopolis-stage-10-player-motor-pool-13-5",
            "type": "motor-pool",
            "owner": "player",
            "x": 13,
            "y": 5
          },
          {
            "id": "mereopolis-stage-10-player-sector-14-5",
            "type": "sector",
            "owner": "player",
            "x": 14,
            "y": 5
          },
          {
            "id": "mereopolis-stage-10-player-command-13-6",
            "type": "command",
            "owner": "player",
            "x": 13,
            "y": 6
          }
        ],
        "units": [
          {
            "id": "mereopolis-stage-10-enemy-breaker-3-0",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 7,
            "x": 3,
            "y": 0
          },
          {
            "id": "mereopolis-stage-10-enemy-bruiser-4-0",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 7,
            "x": 4,
            "y": 0
          },
          {
            "id": "mereopolis-stage-10-enemy-juggernaut-5-0",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 7,
            "x": 5,
            "y": 0
          },
          {
            "id": "mereopolis-stage-10-enemy-gunship-1-1",
            "unitTypeId": "gunship",
            "owner": "enemy",
            "level": 7,
            "x": 1,
            "y": 1
          },
          {
            "id": "mereopolis-stage-10-enemy-grunt-3-1",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 7,
            "x": 3,
            "y": 1
          },
          {
            "id": "mereopolis-stage-10-enemy-longshot-5-1",
            "unitTypeId": "longshot",
            "owner": "enemy",
            "level": 7,
            "x": 5,
            "y": 1
          },
          {
            "id": "mereopolis-stage-10-enemy-breaker-3-2",
            "unitTypeId": "breaker",
            "owner": "enemy",
            "level": 7,
            "x": 3,
            "y": 2
          },
          {
            "id": "mereopolis-stage-10-enemy-grunt-3-3",
            "unitTypeId": "grunt",
            "owner": "enemy",
            "level": 7,
            "x": 3,
            "y": 3
          },
          {
            "id": "mereopolis-stage-10-enemy-bruiser-3-4",
            "unitTypeId": "bruiser",
            "owner": "enemy",
            "level": 7,
            "x": 3,
            "y": 4
          },
          {
            "id": "mereopolis-stage-10-enemy-juggernaut-3-5",
            "unitTypeId": "juggernaut",
            "owner": "enemy",
            "level": 7,
            "x": 3,
            "y": 5
          }
        ],
        "reinforcements": [
          {
            "id": "wave-1",
            "name": "Wave 1",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-1-longshot-2-1",
                "unitTypeId": "longshot",
                "level": 7,
                "x": 2,
                "y": 1
              },
              {
                "id": "wave-1-breaker-3-1",
                "unitTypeId": "breaker",
                "level": 7,
                "x": 3,
                "y": 1
              },
              {
                "id": "wave-1-medic-2-2",
                "unitTypeId": "medic",
                "level": 7,
                "x": 2,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-2",
            "name": "Wave 2",
            "maxActivations": 1,
            "trigger": {
              "type": "enemy-casualties",
              "every": 1
            },
            "units": [
              {
                "id": "wave-2-breaker-3-1",
                "unitTypeId": "breaker",
                "level": 7,
                "x": 3,
                "y": 1
              }
            ]
          },
          {
            "id": "wave-3",
            "name": "Wave 3",
            "maxActivations": 1,
            "trigger": {
              "type": "unit-killed",
              "targetUnitId": "mereopolis-stage-10-enemy-gunship-1-1"
            },
            "units": [
              {
                "id": "wave-3-interceptor-2-0",
                "unitTypeId": "interceptor",
                "level": 7,
                "x": 2,
                "y": 0
              },
              {
                "id": "wave-3-payload-1-2",
                "unitTypeId": "payload",
                "level": 6,
                "x": 1,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-4",
            "name": "Wave 4",
            "maxActivations": 1,
            "trigger": {
              "type": "enemy-casualties",
              "every": 1
            },
            "units": [
              {
                "id": "wave-4-grunt-3-1",
                "unitTypeId": "grunt",
                "level": 7,
                "x": 3,
                "y": 1
              }
            ]
          },
          {
            "id": "wave-5",
            "name": "Wave 5: Boss Breaker",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-5-breaker-3-2",
                "unitTypeId": "breaker",
                "level": 8,
                "x": 3,
                "y": 2
              }
            ]
          },
          {
            "id": "wave-6",
            "name": "Wave 6: Boss Grunt",
            "maxActivations": 1,
            "trigger": {
              "type": "player-turns-completed",
              "every": 1
            },
            "units": [
              {
                "id": "wave-6-breaker-3-1",
                "unitTypeId": "breaker",
                "level": 8,
                "x": 3,
                "y": 1
              }
            ]
          }
        ],
        "goal": {
          "type": "defend",
          "target": {
            "x": 13,
            "y": 6
          },
          "turnLimit": 8
        },
        "runStages": [
          10
        ],
        "stage": 10,
        "variantStage": 10
      }
    ]
  }
};
